import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import React, { useContext, useMemo, useReducer, useEffect, Fragment, useState, createContext, memo } from 'react';
import { extendableUseAppState, useAppState as useAppState$1, AppContext } from '@core-ui/app-state-provider';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { css, jsx, forBrands } from '@core-ui/react-stitch';
import _typeof from '@babel/runtime/helpers/typeof';
import merge from 'lodash/merge';
import ErrorBoundary from '@core-ui/error-boundary';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { useLocalize } from '@core-ui/localization-provider';
import classnames from 'classnames';
import DimensionStockIndicator from '@core-ui/stock-indicator';
import { PersonalizationContext } from '@core-ui/personalization-provider';
import { Capitalization, ComposableButton } from '@core-ui/composable-button';
import { AnimationStatus } from '@core-ui/button';
import he from 'he';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ReviewRatings from '@core-ui/review-ratings';
import { Modal as Modal$1 } from '@core-ui/modal';
import { jsx as jsx$1 } from '@emotion/react';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

function errorMessageStyles(theme) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    ", "\n    position: relative;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    font-size: 0.875rem;\n    border-color: ", ";\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    width: auto;\n    flex: auto;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0QwMDAwMCIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTExLjU3OSAxNC4zNGMwIC44MjgtLjY3MiAxLjQ1LTEuNTc1IDEuNDUtLjkwNCAwLTEuNTgzLS42MjItMS41ODMtMS40NSAwLS44MzIuNjc3LTEuNDU2IDEuNTgzLTEuNDU2LjkwNSAwIDEuNTc1LjYyMyAxLjU3NSAxLjQ1NnpNOC42ODUgNC4yMWgyLjYzdjcuMjU3aC0yLjYzVjQuMjExeiIvPjwvZz48L3N2Zz4=)\n        no-repeat;\n    }\n  "], ["\n    color: ", ";\n    ", "\n    position: relative;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    font-size: 0.875rem;\n    border-color: ", ";\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    width: auto;\n    flex: auto;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIgZmlsbD0iI0QwMDAwMCIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTExLjU3OSAxNC4zNGMwIC44MjgtLjY3MiAxLjQ1LTEuNTc1IDEuNDUtLjkwNCAwLTEuNTgzLS42MjItMS41ODMtMS40NSAwLS44MzIuNjc3LTEuNDU2IDEuNTgzLTEuNDU2LjkwNSAwIDEuNTc1LjYyMyAxLjU3NSAxLjQ1NnpNOC42ODUgNC4yMWgyLjYzdjcuMjU3aC0yLjYzVjQuMjExeiIvPjwvZz48L3N2Zz4=)\n        no-repeat;\n    }\n  "])), theme.color.bk, theme.crossBrand.font.primary, theme.crossBrand.color.err1);
}

var templateObject_1;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$.apply(this, arguments);
};

function __makeTemplateObject$1(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var visuallyHide = function visuallyHide() {
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject$1(["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "], ["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "])));
};

var templateObject_6;

function backorderMessageStyles(theme) {
  return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n    ", "\n    text-align: left;\n    top: 0;\n    left: 0;\n    transform: translate(0, calc(-100% - 0.75rem));\n    font-size: 0.75rem;\n    color: ", ";\n    z-index: 10;\n    text-transform: none;\n    background-color: ", ";\n    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    line-height: 1.5;\n    white-space: normal;\n\n    .dimensions-group & {\n      letter-spacing: normal;\n    }\n\n    &.backorder-color--show {\n      transform: translate(0, calc(-100% + 1.75rem));\n    }\n\n    .swatch--dimension:hover &,\n    .pdp-dimension:hover &,\n    .swatch--dimension .swatch__radio.focus-visible ~ &,\n    .pdp-dimension .pdp-dimension__radio.focus-visible ~ &,\n    &.backorder-color--show {\n      @media (min-width: 768px) {\n        height: auto;\n        width: 9.375rem;\n        overflow: visible;\n        clip: initial;\n      }\n    }\n  "], ["\n    ", "\n    text-align: left;\n    top: 0;\n    left: 0;\n    transform: translate(0, calc(-100% - 0.75rem));\n    font-size: 0.75rem;\n    color: ", ";\n    z-index: 10;\n    text-transform: none;\n    background-color: ", ";\n    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    line-height: 1.5;\n    white-space: normal;\n\n    .dimensions-group & {\n      letter-spacing: normal;\n    }\n\n    &.backorder-color--show {\n      transform: translate(0, calc(-100% + 1.75rem));\n    }\n\n    .swatch--dimension:hover &,\n    .pdp-dimension:hover &,\n    .swatch--dimension .swatch__radio.focus-visible ~ &,\n    .pdp-dimension .pdp-dimension__radio.focus-visible ~ &,\n    &.backorder-color--show {\n      @media (min-width: 768px) {\n        height: auto;\n        width: 9.375rem;\n        overflow: visible;\n        clip: initial;\n      }\n    }\n  "])), visuallyHide(), theme.color.g1, theme.color.wh);
}

var templateObject_1$1;

function DimensionRadio(_a) {
  var backOrderMessage = _a.backOrderMessage,
      id = _a.id,
      _b = _a.inStock,
      inStock = _b === void 0 ? true : _b,
      name = _a.name,
      value = _a.value,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      _c = _a.selected,
      selected = _c === void 0 ? false : _c,
      _d = _a.shouldDisplayInStock,
      shouldDisplayInStock = _d === void 0 ? true : _d,
      visibleBackOrderTooltip = _a.visibleBackOrderTooltip,
      className = _a.className,
      triggerProps = _a.triggerProps;
  var localize = useLocalize().localize;
  var isLong = value.length > 3;
  var dimensionClasses = classnames('pdp-dimension', {
    selected: selected,
    'pdp-dimension--unavailable': !inStock,
    'pdp-dimension--auto-width': isLong
  });
  return jsx("div", {
    className: className + " " + dimensionClasses,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, jsx("input", _assign$({
    "aria-disabled": !inStock ? 'true' : 'false',
    "aria-label": !inStock ? localize('dimensionRadio.outOfStock', {
      dimension: value
    }) : value,
    checked: selected,
    className: "pdp-dimension__radio",
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    type: "radio",
    value: value
  }, triggerProps)), jsx("span", {
    "aria-hidden": true,
    className: "pdp-dimension__label"
  }, jsx("span", {
    className: "pdp-dimension__text"
  }, value)), shouldDisplayInStock && jsx(DimensionStockIndicator, {
    inStock: inStock
  }), backOrderMessage && visibleBackOrderTooltip && jsx("span", {
    "aria-hidden": "true",
    className: "backorder-message",
    css: backorderMessageStyles,
    "data-testid": "dimension-radio-backorder-message"
  }, backOrderMessage.mainText));
}

var swatchSize = '40px';
var swatchSpacing = '0.75rem';
var swatchSpacingVertical = '1rem';

function dimensionRadioStyles(theme) {
  var radioBackgroundColor = forBrands(theme, {
    gap: function gap() {
      return theme.color.g5;
    },
    gapfs: function gapfs() {
      return theme.color.g5;
    },
    at: function at() {
      return theme.color.g5;
    }
  });
  var radioStyles = forBrands(theme, {
    br: function br() {
      return "1px solid " + theme.color.g4;
    },
    brfs: function brfs() {
      return "1px solid " + theme.color.g4;
    },
    gap: function gap() {
      return 'none';
    },
    gapfs: function gapfs() {
      return 'none';
    },
    on: function on() {
      return "1px solid " + theme.color.b1;
    }
  });
  var borderRadius = forBrands(theme, {
    at: function at() {
      return '1.5rem';
    }
  });
  var wrapperBackgroundColor = forBrands(theme, {
    gap: function gap() {
      return theme.color.b1;
    },
    gapfs: function gapfs() {
      return theme.color.b1;
    },
    at: function at() {
      return theme.color.g1;
    },
    br: function br() {
      return theme.color.g1;
    },
    brfs: function brfs() {
      return theme.color.g1;
    },
    on: function on() {
      return theme.color.g1;
    }
  });
  return css(templateObject_1$1$1 || (templateObject_1$1$1 = __makeTemplateObject$1(["\n    position: relative;\n    display: inline-block;\n    margin-right: ", ";\n    margin-bottom: ", ";\n    text-align: center;\n    transition: all 0.2s;\n    vertical-align: top;\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n    }\n\n    &.invisible-border {\n      border-right: 0.375rem solid transparent;\n      border-left: 0.375rem solid transparent;\n      margin-right: 0 !important;\n      float: left;\n    }\n\n    & .swatch__out-of-stock-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      border-radius: ", ";\n    }\n\n    & .pdp-dimension__radio {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: 0;\n      z-index: 1;\n      transform: translate(-50%, -50%);\n      opacity: 0;\n    }\n\n    & .pdp-dimension__radio:hover {\n      cursor: pointer;\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      box-shadow: 0 0 0 0.1875rem ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      content: '';\n      position: absolute;\n      display: block;\n      height: 0.25rem;\n      width: 100%;\n      bottom: -0.5rem;\n      left: 0;\n      background-color: ", ";\n    }\n  "], ["\n    position: relative;\n    display: inline-block;\n    margin-right: ", ";\n    margin-bottom: ", ";\n    text-align: center;\n    transition: all 0.2s;\n    vertical-align: top;\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: ", ";\n    }\n\n    &.invisible-border {\n      border-right: 0.375rem solid transparent;\n      border-left: 0.375rem solid transparent;\n      margin-right: 0 !important;\n      float: left;\n    }\n\n    & .swatch__out-of-stock-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      border-radius: ", ";\n    }\n\n    & .pdp-dimension__radio {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: 0;\n      z-index: 1;\n      transform: translate(-50%, -50%);\n      opacity: 0;\n    }\n\n    & .pdp-dimension__radio:hover {\n      cursor: pointer;\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      box-shadow: 0 0 0 0.1875rem ", ";\n    }\n\n    &.pdp-dimension.selected::after {\n      content: '';\n      position: absolute;\n      display: block;\n      height: 0.25rem;\n      width: 100%;\n      bottom: -0.5rem;\n      left: 0;\n      background-color: ", ";\n    }\n  "])), swatchSpacing, swatchSpacingVertical, radioBackgroundColor, radioStyles, borderRadius, swatchSize, swatchSize, swatchSize, borderRadius, theme.crossBrand.color.b2, wrapperBackgroundColor);
}

var templateObject_1$1$1;

function useTextStyles(theme) {
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var abbrBrand = useAppState$1().brandName;
  var newFontFeatureFlag = ['br', 'brfs'].includes(abbrBrand) ? 'enable-new-br-fonts' : '';
  var isNewBrFontEnabled = enabledFeatures[newFontFeatureFlag];
  var naturalLineHeight = forBrands(theme, {
    gap: function gap() {
      return '41px';
    },
    gapfs: function gapfs() {
      return '41px';
    },
    br: function br() {
      return '41px';
    },
    brfs: function brfs() {
      return '41px';
    },
    on: function on() {
      return '42px';
    },
    at: function at() {
      return '39px';
    }
  });
  var swatchTextColor = forBrands(theme, {
    gap: theme.color.b2,
    gapfs: theme.color.b2,
    br: function br() {
      return theme.color.g2;
    },
    brfs: function brfs() {
      return theme.color.g3;
    },
    on: function on() {
      return theme.color.b1;
    }
  });
  var checkedSwatchColor = forBrands(theme, {
    br: function br() {
      return theme.color.g1;
    },
    brfs: function brfs() {
      return theme.color.g1;
    },
    on: function on() {
      return theme.color.g1;
    }
  });
  var checkedBackgroundColor = forBrands(theme, {
    br: function br() {
      return theme.color.g1;
    },
    brfs: function brfs() {
      return theme.color.g1;
    },
    on: function on() {
      return theme.color.g1;
    },
    at: function at() {
      return theme.color.g5;
    }
  });
  var checkedSwatchTextColor = forBrands(theme, {
    gap: function gap() {
      return theme.color.b1;
    },
    gapfs: function gapfs() {
      return theme.color.b1;
    },
    br: function br() {
      return theme.color.wh;
    },
    brfs: function brfs() {
      return theme.color.wh;
    },
    on: function on() {
      return theme.color.wh;
    }
  });
  var checkedSwatchFont = forBrands(theme, {
    gap: function gap() {
      return theme.crossBrand.font.secondary;
    },
    at: function at() {
      return theme.crossBrand.font.secondary;
    }
  });
  var checkedSwatchFontWeight = forBrands(theme, {
    gapfs: function gapfs() {
      return 700;
    }
  });
  var unavailableTextColor = forBrands(theme, {
    br: function br() {
      return theme.color.g4;
    },
    brfs: function brfs() {
      return theme.color.g4;
    },
    gap: function gap() {
      return theme.color.g2;
    },
    gapfs: function gapfs() {
      return theme.color.g2;
    }
  });
  var unavailableTextFont = forBrands(theme, {
    gap: function gap() {
      return theme.crossBrand.font.primary;
    },
    gapfs: function gapfs() {
      return theme.crossBrand.font.primary;
    }
  });
  var unavailableCheckedBackground = forBrands(theme, {
    on: function on() {
      return theme.color.wh;
    }
  });
  var unavailableCheckedBorder = forBrands(theme, {
    on: function on() {
      return theme.color.g4;
    }
  });
  var unavailableCheckedTextColor = forBrands(theme, {
    on: function on() {
      return theme.color.g3;
    }
  });
  var textFontSize = forBrands(theme, {
    gap: '0.933rem',
    gapfs: '0.933rem',
    on: function on() {
      return '0.9rem';
    },
    br: function br() {
      return isNewBrFontEnabled ? '1rem' : '0.8125rem';
    },
    at: function at() {
      return '1rem';
    },
    default: function _default() {
      return '0.8125rem';
    }
  });
  var swatchTextTransform = forBrands(theme, {
    gap: 'uppercase',
    gapfs: 'uppercase',
    on: 'uppercase',
    br: 'uppercase'
  });
  var brStyles = {
    fontSize: isNewBrFontEnabled ? '1rem' : ''
  };
  var optionsStyles = forBrands(theme, {
    br: brStyles,
    brfs: brStyles
  });
  var brSelectedStyles = isNewBrFontEnabled ? {
    padding: '2px'
  } : {};
  var brVariantSelectedStyles = forBrands(theme, {
    br: brSelectedStyles,
    brfs: brSelectedStyles
  });
  return css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$1(["\n    text-transform: ", ";\n    letter-spacing: normal;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    ", "\n    line-height: ", ";\n    white-space: nowrap;\n\n    &.selected {\n      font-family: ", ";\n      color: ", ";\n      font-weight: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & .pdp-dimension__text {\n      ", ";\n      display: block;\n      position: relative;\n    }\n\n    & .pdp-dimension__label {\n      box-sizing: border-box;\n      display: inline-block;\n      width: 100%;\n      height: 100%;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      padding: 0 1em;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__label {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension.pdp-dimension--auto-width .pdp-dimension__label {\n      z-index: 0;\n    }\n  "], ["\n    text-transform: ", ";\n    letter-spacing: normal;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    ", "\n    line-height: ", ";\n    white-space: nowrap;\n\n    &.selected {\n      font-family: ", ";\n      color: ", ";\n      font-weight: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    & .pdp-dimension__text {\n      ", ";\n      display: block;\n      position: relative;\n    }\n\n    & .pdp-dimension__label {\n      box-sizing: border-box;\n      display: inline-block;\n      width: 100%;\n      height: 100%;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      padding: 0 1em;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__label {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n      z-index: 1;\n    }\n\n    &.pdp-dimension.pdp-dimension--auto-width .pdp-dimension__label {\n      z-index: 0;\n    }\n  "])), swatchTextTransform, textFontSize, swatchTextColor, theme.font.primary, naturalLineHeight, checkedSwatchFont, checkedSwatchTextColor, checkedSwatchFontWeight, checkedSwatchColor, checkedBackgroundColor, brVariantSelectedStyles, unavailableTextColor, unavailableTextFont, unavailableCheckedTextColor, unavailableCheckedBackground, unavailableCheckedBorder, optionsStyles);
}

var templateObject_1$2;

function theme2019Styles(theme, gothamFontEnabled) {
  var fixedSwatchSize = forBrands(theme, {
    default: function _default() {
      return '2.25rem';
    }
  });
  var swatchNaturalLineHeight = forBrands(theme, {
    br: function br() {
      return '2.375';
    },
    gap: function gap() {
      return '2';
    },
    default: function _default() {
      return '1.875';
    }
  });
  var textColor = forBrands(theme, {
    default: function _default() {
      return theme.color.g1;
    }
  });
  var paddingTop = forBrands(theme, {
    brfs: function brfs() {
      return '0.27em';
    },
    default: function _default() {
      return '0';
    }
  });
  var textFontSize = forBrands(theme, {
    gap: function gap() {
      return '1rem';
    },
    gapfs: function gapfs() {
      return '1rem';
    },
    br: function br() {
      return '0.875rem';
    },
    brfs: function brfs() {
      return '0.875rem';
    },
    default: function _default() {
      return '1.125rem';
    }
  });
  var textLetterSpacing = forBrands(theme, {
    br: function br() {
      return '1px';
    }
  });
  var textFontWeight = forBrands(theme, {
    br: function br() {
      return '400';
    }
  });
  var swatchCheckedFontWeight = forBrands(theme, {
    at: function at() {
      return '600';
    },
    default: function _default() {
      return '700';
    }
  });
  var textTopPosition = forBrands(theme, {
    at: '45%',
    default: '50%'
  });
  var unavailableTextColor = forBrands(theme, {
    br: function br() {
      return theme.color.g4;
    },
    brfs: function brfs() {
      return theme.color.g4;
    },
    gap: function gap() {
      return theme.color.g2;
    },
    gapfs: function gapfs() {
      return theme.color.g2;
    }
  });
  var unavailableTextFont = forBrands(theme, {
    gap: function gap() {
      return theme.crossBrand.font.primary;
    },
    gapfs: function gapfs() {
      return theme.crossBrand.font.primary;
    }
  });
  return css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$1(["\n    margin-bottom: 0.8125rem;\n    border: none;\n    text-transform: capitalize;\n    ", "\n    font-size: ", ";\n    color: ", ";\n    letter-spacing: ", ";\n    font-weight: ", ";\n    border-radius: 2rem;\n    line-height: ", ";\n    background-color: transparent;\n    position: relative;\n\n    ", "\n\n    &.selected {\n      color: ", ";\n      font-weight: ", ";\n      background-color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      font-weight: 400;\n      background-color: ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 2.125rem;\n      margin-right: 0;\n      margin-bottom: 0.125rem;\n      padding: 0;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      position: relative;\n      padding: ", " 0.875em 0;\n\n      ", "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      top: ", ";\n    }\n\n    &.pdp-dimension--unavailable .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n    }\n\n    &.pdp-dimension.selected::after {\n      display: none;\n    }\n\n    &.pdp-dimension .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 2rem;\n    }\n  "], ["\n    margin-bottom: 0.8125rem;\n    border: none;\n    text-transform: capitalize;\n    ", "\n    font-size: ", ";\n    color: ", ";\n    letter-spacing: ", ";\n    font-weight: ", ";\n    border-radius: 2rem;\n    line-height: ", ";\n    background-color: transparent;\n    position: relative;\n\n    ", "\n\n    &.selected {\n      color: ", ";\n      font-weight: ", ";\n      background-color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      color: ", ";\n      font-weight: 400;\n      background-color: ", ";\n    }\n\n    &.pdp-dimension--unavailable {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: ", ";\n      height: ", ";\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 2.125rem;\n      margin-right: 0;\n      margin-bottom: 0.125rem;\n      padding: 0;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      position: relative;\n      padding: ", " 0.875em 0;\n\n      ", "\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) .pdp-dimension__text {\n      top: ", ";\n    }\n\n    &.pdp-dimension--unavailable .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n    }\n\n    &.pdp-dimension.selected::after {\n      display: none;\n    }\n\n    &.pdp-dimension .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 2rem;\n    }\n  "])), theme.font.primary, textFontSize, textColor, textLetterSpacing, textFontWeight, swatchNaturalLineHeight, gothamFontEnabled && "font-size: 0.875rem;", theme.color.wh, swatchCheckedFontWeight, theme.color.b1, theme.color.bk, theme.color.gray10, unavailableTextColor, unavailableTextFont, fixedSwatchSize, fixedSwatchSize, paddingTop, gothamFontEnabled && "\n        display: flex;\n        align-items: center;\n      ", textTopPosition);
}

var templateObject_1$3;

function quickAddStyles(theme, gothamFontEnabled) {
  return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$1(["\n    font-size: 0.75rem;\n    line-height: 2.125;\n\n    &.selected {\n      font-weight: 700;\n    }\n\n    &.pdp-dimension--unavailable {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      font-weight: 400;\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 1.875rem;\n      height: 1.875rem;\n      margin: 0 0.5rem 0.75rem;\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 1.875rem;\n      margin-bottom: 0;\n      margin-right: 0;\n      margin-left: 0;\n      font-size: 0.875rem;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      padding: 0 0.7em;\n\n      ", "\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    & .swatch__out-of-stock-indicator {\n      z-index: 2;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 1rem;\n    }\n\n    &.pdp-dimension--unavailable.selected .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n    }\n  "], ["\n    font-size: 0.75rem;\n    line-height: 2.125;\n\n    &.selected {\n      font-weight: 700;\n    }\n\n    &.pdp-dimension--unavailable {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &.selected.pdp-dimension--unavailable {\n      font-weight: 400;\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 1.875rem;\n      height: 1.875rem;\n      margin: 0 0.5rem 0.75rem;\n    }\n\n    &.pdp-dimension--auto-width {\n      width: auto;\n      height: 1.875rem;\n      margin-bottom: 0;\n      margin-right: 0;\n      margin-left: 0;\n      font-size: 0.875rem;\n    }\n\n    & .pdp-dimension__label {\n      border-radius: 2rem;\n    }\n\n    &.pdp-dimension--auto-width .pdp-dimension__label {\n      width: auto;\n      margin-right: 0;\n      padding: 0 0.7em;\n\n      ", "\n    }\n\n    & .pdp-dimension__radio.focus-visible + .pdp-dimension__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n\n    & .swatch__out-of-stock-indicator {\n      z-index: 2;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      pointer-events: none;\n      transform: scale(1);\n      border-radius: 50%;\n    }\n\n    &.pdp-dimension--auto-width .swatch__out-of-stock-indicator {\n      transform: scale(1);\n      border-radius: 1rem;\n    }\n\n    &.pdp-dimension--unavailable.selected .pdp-dimension__radio:checked + .pdp-dimension__label .pdp-dimension__text {\n      opacity: 0.5;\n    }\n  "])), theme.color.wh, theme.color.g4, theme.color.bk, theme.color.gray10, theme.color.bk, gothamFontEnabled && "\n        display: flex;\n        align-items: center;\n      ", theme.crossBrand.color.b2);
}

function quickAddWithImageStyles(theme, gothamFontEnabled) {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject$1(["\n    ", "\n    line-height: 2;\n\n    &.pdp-dimension--auto-width {\n      height: 2.25rem;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 2.25rem;\n      height: 2.25rem;\n      margin-right: 2.6875rem;\n\n      :nth-of-type(4n) {\n        margin-right: 0px;\n      }\n\n      @media (max-width: 320px) {\n        margin-right: 1.25rem;\n      }\n\n      @media (max-width: 693px) {\n        margin-right: 2.1875rem;\n      }\n    }\n  "], ["\n    ", "\n    line-height: 2;\n\n    &.pdp-dimension--auto-width {\n      height: 2.25rem;\n    }\n\n    &.pdp-dimension:not(.pdp-dimension--auto-width) {\n      width: 2.25rem;\n      height: 2.25rem;\n      margin-right: 2.6875rem;\n\n      :nth-of-type(4n) {\n        margin-right: 0px;\n      }\n\n      @media (max-width: 320px) {\n        margin-right: 1.25rem;\n      }\n\n      @media (max-width: 693px) {\n        margin-right: 2.1875rem;\n      }\n    }\n  "])), quickAddStyles(theme, gothamFontEnabled));
}

var templateObject_1$4, templateObject_2;

var errorStyles = function errorStyles(theme) {
  return css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  ", "\n  border: 0;\n  border-style: none;\n  flex: none;\n"], ["\n  ", "\n  border: 0;\n  border-style: none;\n  flex: none;\n"])), errorMessageStyles(theme));
};

var baseStyles = function baseStyles() {
  return css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  height: 36px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    margin-top: 0.18rem;\n    margin-left: 0.23rem;\n  }\n"], ["\n  height: 36px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    margin-top: 0.18rem;\n    margin-left: 0.23rem;\n  }\n"])));
};

var templateObject_1$5, templateObject_2$1;
var styleConstants = {
  disabledBorderColor: '#979797'
};

var addToBagStyles = function addToBagStyles(theme, isNewBrFontEnabled) {
  var fontSize = forBrands(theme, {
    default: function _default() {
      return '0.75rem';
    }
  });
  var fontWeight = forBrands(theme, {
    at: function at() {
      return 600;
    },
    br: function br() {
      return isNewBrFontEnabled ? 600 : 700;
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 600 : 700;
    },
    default: function _default() {
      return 700;
    }
  });
  var letterSpacing = forBrands(theme, {
    default: '0.5px'
  });
  return css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    ", "\n    margin-top: 1rem;\n    background-color: ", ";\n    color: ", ";\n    ", "\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n\n    &.add-to-bag--disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &.focus-visible {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "], ["\n    ", "\n    margin-top: 1rem;\n    background-color: ", ";\n    color: ", ";\n    ", "\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n\n    &.add-to-bag--disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &.focus-visible {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "])), baseStyles(), theme.color.b1, theme.color.wh, theme.font.primary, fontSize, fontWeight, letterSpacing, theme.color.wh, theme.color.gray54, styleConstants.disabledBorderColor, theme.crossBrand.color.b2);
};

var templateObject_1$6;

var sdsHeadingE = function sdsHeadingE(theme) {
  var textFontSize = forBrands(theme, {
    gap: function gap() {
      return '0.933rem';
    },
    gapfs: function gapfs() {
      return '0.933rem';
    },
    on: function on() {
      return '0.9rem';
    },
    br: function br() {
      return '0.8125rem';
    },
    brfs: function brfs() {
      return '0.8125rem';
    },
    at: function at() {
      return '1rem';
    },
    default: function _default() {
      return '0.8125rem';
    }
  });
  var fontExtras = forBrands(theme, {
    at: function at() {
      return "\n      font-variant-ligatures: none;\n      letter-spacing: 0.5px;\n    ";
    }
  });
  var textColor = forBrands(theme, {
    at: function at() {
      return theme.color.g1;
    },
    br: function br() {
      return theme.color.g2;
    },
    brfs: function brfs() {
      return theme.color.g2;
    },
    gap: function gap() {
      return theme.color.b1;
    },
    gapfs: function gapfs() {
      return theme.color.b1;
    },
    on: function on() {
      return theme.color.b1;
    }
  });
  return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    ", "\n  "])), textColor, textFontSize, fontExtras);
};

var sdsBodyA = function sdsBodyA(theme) {
  var fontHeight = forBrands(theme, {
    gap: function gap() {
      return '1.38';
    },
    gapfs: function gapfs() {
      return '1.38';
    },
    on: function on() {
      return '1.38';
    },
    br: function br() {
      return '1.43';
    },
    brfs: function brfs() {
      return '1.43';
    },
    at: function at() {
      return '1.4';
    }
  });
  var fontColor = forBrands(theme, {
    gap: function gap() {
      return theme.color.g2;
    },
    gapfs: function gapfs() {
      return theme.color.g2;
    },
    on: function on() {
      return theme.color.g2;
    },
    br: function br() {
      return theme.color.g1;
    },
    brfs: function brfs() {
      return theme.color.g1;
    },
    at: function at() {
      return theme.color.g1;
    }
  });
  var fontSize = forBrands(theme, {
    gap: function gap() {
      return '0.867rem';
    },
    gapfs: function gapfs() {
      return '0.867rem';
    },
    on: function on() {
      return '0.867rem';
    },
    br: function br() {
      return '0.875rem';
    },
    brfs: function brfs() {
      return '0.875rem';
    },
    at: function at() {
      return '0.875rem';
    }
  });
  var fontExtras = forBrands(theme, {
    at: function at() {
      return "\n      font-variant-ligatures: none;\n    ";
    }
  });
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    line-height: ", ";\n    color: ", ";\n    font-size: ", ";\n    ", "\n    font-weight: lighter;\n    ", "\n  "], ["\n    line-height: ", ";\n    color: ", ";\n    font-size: ", ";\n    ", "\n    font-weight: lighter;\n    ", "\n  "])), fontHeight, fontColor, fontSize, theme.font.primary, fontExtras);
};

var visuallyHide$1 = function visuallyHide$1() {
  return css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "], ["\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n  "])));
};

var templateObject_2$2, templateObject_3, templateObject_6$1;

var addToBagButtonStyles = function addToBagButtonStyles(theme, isNewBrFontEnabled) {
  return css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), addToBagStyles(theme, isNewBrFontEnabled));
};

var productTitleStyles = css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), visuallyHide$1());

var dimensionRadioStyles$1 = function dimensionRadioStyles$1(theme, gothamFontEnabled) {
  return css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), dimensionRadioStyles(theme), useTextStyles(theme), theme2019Styles(theme), quickAddStyles(theme, gothamFontEnabled));
};

var dimensionGroupsContainerStyles = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n"], ["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n"])), visuallyHide$1());

var radioGroupStyles = function radioGroupStyles(theme, gothamFontEnabled, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    default: function _default() {
      return 700;
    }
  });
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-size: 0.7rem;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n  "], ["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-size: 0.7rem;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n  "])), brFontWeightStyles);
};

var sizeSelectorStyles = function sizeSelectorStyles() {
  return css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n    flex-grow: 1;\n    overflow-y: auto;\n  "], ["\n    flex-grow: 1;\n    overflow-y: auto;\n  "])));
};

var templateObject_1$7, templateObject_2$3, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6$2;

var addToBagButtonStyles$1 = function addToBagButtonStyles$1(theme, isNewBrFontEnabled) {
  return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    display: block;\n    margin-top: auto;\n  "], ["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    display: block;\n    margin-top: auto;\n  "])), addToBagStyles(theme, isNewBrFontEnabled));
};

var dimensionsContainerStyles = css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  flex-direction: column;\n  padding: 0 2rem 2rem 0;\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 693px) {\n    padding: 0 0.5rem 0.5rem 0.5rem;\n    min-height: 19rem;\n  }\n"], ["\n  flex-direction: column;\n  padding: 0 2rem 2rem 0;\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 693px) {\n    padding: 0 0.5rem 0.5rem 0.5rem;\n    min-height: 19rem;\n  }\n"])));

var dimensionGroupsContainerStyles$1 = css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n\n  .radio-container:not(:first-of-type):last-child {\n    margin-bottom: 2.125rem;\n\n    .dimension-group {\n      align-content: center;\n\n      .pdp-dimension {\n        margin-right: 0.5rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n"], ["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n\n  .radio-container:not(:first-of-type):last-child {\n    margin-bottom: 2.125rem;\n\n    .dimension-group {\n      align-content: center;\n\n      .pdp-dimension {\n        margin-right: 0.5rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n"])), visuallyHide$1());

var dimensionRadioStyles$2 = function dimensionRadioStyles$2(theme, gothamFontEnabled) {
  return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), dimensionRadioStyles(theme), useTextStyles(theme), theme2019Styles(theme), quickAddWithImageStyles(theme, gothamFontEnabled));
};

var imageContainerStyles = css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  min-height: 20.938rem;\n  width: 260px;\n  padding: 0 2.5rem 2rem 2rem;\n\n  @media (max-width: 693px) {\n    min-height: unset;\n    padding: 0 2rem 2rem 2rem;\n    width: unset;\n  }\n"], ["\n  min-height: 20.938rem;\n  width: 260px;\n  padding: 0 2.5rem 2rem 2rem;\n\n  @media (max-width: 693px) {\n    min-height: unset;\n    padding: 0 2rem 2rem 2rem;\n    width: unset;\n  }\n"])));

var imageStyles = css(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  height: 100%;\n  object-fit: cover;\n\n  @media (max-width: 693px) {\n    width: 8rem;\n    height: 10.688rem;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"], ["\n  height: 100%;\n  object-fit: cover;\n\n  @media (max-width: 693px) {\n    width: 8rem;\n    height: 10.688rem;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"])));

var productTitleStyles$1 = function productTitleStyles$1(theme) {
  return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), visuallyHide$1());
};

var radioGroupStyles$1 = function radioGroupStyles$1(theme, gothamFontEnabled, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    default: function _default() {
      return 700;
    }
  });
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        line-height: ", ";\n      }\n    }\n  "], ["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        line-height: ", ";\n      }\n    }\n  "])), brFontWeightStyles, gothamFontEnabled ? '2.5' : '2.1', gothamFontEnabled ? '2.5' : '2.2');
};

var sizeSelectorStyles$1 = function sizeSelectorStyles$1(theme, gothamFontEnabled) {
  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 20.063rem;\n\n    * {\n      font-size: ", " !important;\n\n      @media (max-width: 693px) {\n        font-size: ", " !important;\n      }\n    }\n  "], ["\n    width: 20.063rem;\n\n    * {\n      font-size: ", " !important;\n\n      @media (max-width: 693px) {\n        font-size: ", " !important;\n      }\n    }\n  "])), gothamFontEnabled ? '0.875rem' : '1.125rem', gothamFontEnabled ? '0.875rem' : '1rem');
};

var templateObject_1$8, templateObject_2$4, templateObject_3$2, templateObject_4$1, templateObject_5$1, templateObject_6$3, templateObject_7, templateObject_8, templateObject_9;

var addToBagButtonStyles$2 = function addToBagButtonStyles$2(theme, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 'font-weight: 400' : '';
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 'font-weight: 400' : '';
    }
  });
  return css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    display: block;\n    border-width: 1px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.add-to-bag--disabled {\n      .regular-price::before {\n        color: ", ";\n      }\n    }\n\n    .regular-price {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      span {\n        ", ";\n      }\n    }\n\n    .regular-price__pipe {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n\n    .regular-price__line-through::before {\n      padding-right: 1.25rem;\n    }\n\n    .regular-price__line-through {\n      font-weight: 400;\n      text-decoration-line: line-through;\n    }\n\n    @media (max-width: 693px) {\n      width: 100%;\n    }\n  "], ["\n    ", "\n    width: 100%;\n    height: 3.313rem;\n    font-size: 0.875rem;\n    display: block;\n    border-width: 1px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.add-to-bag--disabled {\n      .regular-price::before {\n        color: ", ";\n      }\n    }\n\n    .regular-price {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      span {\n        ", ";\n      }\n    }\n\n    .regular-price__pipe {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n\n    .regular-price__line-through::before {\n      padding-right: 1.25rem;\n    }\n\n    .regular-price__line-through {\n      font-weight: 400;\n      text-decoration-line: line-through;\n    }\n\n    @media (max-width: 693px) {\n      width: 100%;\n    }\n  "])), addToBagStyles(theme, isNewBrFontEnabled), theme.color.gray54, brFontWeightStyles);
};

var colorNameStyles = function colorNameStyles(theme, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 'font-weight: 400;' : '';
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 'font-weight: 400;' : '';
    }
  });
  return css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    padding-top: 0.4375rem;\n    ", "\n    .color-label {\n      font-weight: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    padding-top: 0.4375rem;\n    ", "\n    .color-label {\n      font-weight: ", ";\n    }\n  "])), theme.color.gray80, brFontWeightStyles, isNewBrFontEnabled ? '400' : '700');
};

var containerStyles = css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));

var dimensionsContainerStyles$1 = css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  flex-direction: column;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  min-height: 21.5rem;\n"], ["\n  flex-direction: column;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 0.5rem 0.5rem 0.5rem;\n  min-height: 21.5rem;\n"])));

var dimensionGroupsContainerStyles$2 = css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n\n  .radio-container:not(:first-of-type):last-child {\n    margin-bottom: 2.125rem;\n\n    .dimension-group {\n      align-content: center;\n\n      .pdp-dimension {\n        margin-right: 0.5rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n"], ["\n  > :first-of-type .radio-container__label {\n    ", "\n    margin-left: 0;\n  }\n\n  .radio-container__label {\n    margin-left: 0.5rem;\n  }\n\n  .radio-container:not(:first-of-type):last-child {\n    margin-bottom: 2.125rem;\n\n    .dimension-group {\n      align-content: center;\n\n      .pdp-dimension {\n        margin-right: 0.5rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n"])), visuallyHide$1());

var dimensionRadioStyles$3 = function dimensionRadioStyles$3(theme, gothamFontEnabled) {
  return css(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), dimensionRadioStyles(theme), useTextStyles(theme), theme2019Styles(theme), quickAddWithImageStyles(theme, gothamFontEnabled));
};

var headerStyles = css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));

var imageStyles$1 = css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  float: left;\n  height: 163px;\n  margin: 0 0 38px 8px;\n  width: 124px;\n"], ["\n  float: left;\n  height: 163px;\n  margin: 0 0 38px 8px;\n  width: 124px;\n"])));

var marketingFlagStyles = function marketingFlagStyles(theme, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 'font-weight: 400' : '';
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 'font-weight: 400' : '';
    }
  });
  return css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n    text-align: center;\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.0625rem;\n    padding: 0.125rem 0.5rem 0.3125rem 0.5rem;\n    ", ";\n  "], ["\n    text-align: center;\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: 1.0625rem;\n    padding: 0.125rem 0.5rem 0.3125rem 0.5rem;\n    ", ";\n  "])), theme.color.gray80, brFontWeightStyles);
};

var productInfoStyles = function productInfoStyles(theme) {
  return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  height: fit-content;\n  padding-left: 0.625rem;\n\n  .show-tertiary-font {\n    ", "\n  }\n"], ["\n  height: fit-content;\n  padding-left: 0.625rem;\n\n  .show-tertiary-font {\n    ", "\n  }\n"])), forBrands(theme, {
    br: function br() {
      return theme.font.tertiary;
    },
    brfs: function brfs() {
      return theme.font.tertiary;
    },
    default: function _default() {
      return theme.font.primary;
    }
  }));
};

var productTitleStyles$2 = function productTitleStyles$2(theme, isNewBrFontEnabled) {
  var brStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? theme.font.tertiary : theme.font.secondary;
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? theme.font.tertiary : theme.font.secondary;
    },
    default: function _default() {
      return theme.font.secondary;
    }
  });
  return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    color: ", ";\n    display: block;\n    font-size: 1.125rem;\n    letter-spacing: 0.026rem;\n    line-height: 1.25rem;\n    margin-right: 0.125rem;\n    padding-top: 0.625rem;\n    text-align: left;\n    ", "\n  "], ["\n    color: ", ";\n    display: block;\n    font-size: 1.125rem;\n    letter-spacing: 0.026rem;\n    line-height: 1.25rem;\n    margin-right: 0.125rem;\n    padding-top: 0.625rem;\n    text-align: left;\n    ", "\n  "])), theme.color.b1, brStyles);
};

var radioGroupStyles$2 = function radioGroupStyles$2(theme, gothamFontEnabled, isNewBrFontEnabled) {
  var brFontWeightStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? 400 : 700;
    },
    default: function _default() {
      return 700;
    }
  });
  return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        ", "\n      }\n    }\n  "], ["\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    & .radio-container__label {\n      line-height: 2.5;\n      margin-right: 0.5rem;\n      align-self: baseline;\n      font-weight: ", ";\n    }\n\n    .dimension-group {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    }\n\n    & .radio-container__label {\n      line-height: ", ";\n\n      @media (max-width: 693px) {\n        ", "\n      }\n    }\n  "])), brFontWeightStyles, gothamFontEnabled ? '2.5' : '2.1', !gothamFontEnabled && 'line-height: 2.2;');
};

var sizeSelectorStyles$2 = function sizeSelectorStyles$2(theme, gothamFontEnabled) {
  return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 20.063rem;\n\n    * {\n      font-size: ", " !important;\n    }\n  "], ["\n    width: 20.063rem;\n\n    * {\n      font-size: ", " !important;\n    }\n  "])), gothamFontEnabled ? '0.875rem' : '1rem');
};

var reviewWrapperStyles = css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n"])));

var reviewCountStyles = function reviewCountStyles(theme, isNewBrFontEnabled) {
  var textColor = forBrands(theme, {
    default: theme.color.bk,
    gap: theme.color.b2,
    gapfs: theme.color.b2,
    on: theme.color.b1
  });
  var brStyles = forBrands(theme, {
    br: function br() {
      return isNewBrFontEnabled ? '400' : 'bold';
    },
    brfs: function brfs() {
      return isNewBrFontEnabled ? '400' : 'bold';
    },
    default: function _default() {
      return 'bold';
    }
  });
  return css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.875rem;\n    font-weight: ", ";\n    margin-left: 6px;\n  "], ["\n    color: ", ";\n    font-size: 0.875rem;\n    font-weight: ", ";\n    margin-left: 6px;\n  "])), textColor, brStyles);
};

var templateObject_1$9, templateObject_2$5, templateObject_3$3, templateObject_4$2, templateObject_5$2, templateObject_6$4, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
var STYLES_MAP = {
  default: {
    addToBagButtonStyles: addToBagButtonStyles,
    dimensionGroupsContainerStyles: dimensionGroupsContainerStyles,
    dimensionRadioStyles: dimensionRadioStyles$1,
    radioGroupStyles: radioGroupStyles,
    sizeSelectorStyles: sizeSelectorStyles
  },
  withProductImage: {
    addToBagButtonStyles: addToBagButtonStyles$1,
    dimensionsContainerStyles: dimensionsContainerStyles,
    dimensionGroupsContainerStyles: dimensionGroupsContainerStyles$1,
    dimensionRadioStyles: dimensionRadioStyles$2,
    imageContainerStyles: imageContainerStyles,
    imageStyles: imageStyles,
    productTitleStyles: productTitleStyles$1,
    radioGroupStyles: radioGroupStyles$1,
    sizeSelectorStyles: sizeSelectorStyles$1
  },
  withProductInfo: {
    addToBagButtonStyles: addToBagButtonStyles$2,
    colorNameStyles: colorNameStyles,
    containerStyles: containerStyles,
    dimensionsContainerStyles: dimensionsContainerStyles$1,
    dimensionRadioStyles: dimensionRadioStyles$3,
    dimensionGroupsContainerStyles: dimensionGroupsContainerStyles$2,
    headerStyles: headerStyles,
    imageStyles: imageStyles$1,
    marketingFlagStyles: marketingFlagStyles,
    productInfoStyles: productInfoStyles,
    productTitleStyles: productTitleStyles$2,
    radioGroupStyles: radioGroupStyles$2,
    reviewWrapperStyles: reviewWrapperStyles,
    reviewCountStyles: reviewCountStyles,
    sizeSelectorStyles: sizeSelectorStyles$2
  }
};
var DEFAULT_VERSION = 'default';
var WITH_PRODUCT_IMAGE_VERSION = 'withProductImage';
var WITH_PRODUCT_INFO_VERSION = 'withProductInfo';
var QuickAddContext = /*#__PURE__*/createContext({
  quickAddVersion: DEFAULT_VERSION
});

var QuickAddProvider = function QuickAddProvider(_a) {
  var children = _a.children,
      quickAddVersion = _a.quickAddVersion;
  return /*#__PURE__*/React.createElement(QuickAddContext.Provider, {
    value: {
      quickAddVersion: quickAddVersion,
      styles: STYLES_MAP[quickAddVersion]
    }
  }, children);
};

var QUANTITY_CHANGE = 'QUANTITY_CHANGE';
var VARIANT_CHANGE = 'VARIANT_CHANGE';
var DIMENSION_CHANGE = 'DIMENSION_CHANGE';
var ADD_TO_BAG_REQUEST = 'ADD_TO_BAG_REQUEST';
var ADD_TO_BAG_RESPONSE = 'ADD_TO_BAG_RESPONSE';
var ADD_TO_BAG_SIZE_VALIDATION = 'ADD_TO_BAG_SIZE_VALIDATION';

var setDefaultDimension = function setDefaultDimension(_a) {
  var variant = _a.variant;
  var singleUnitDimensions = variant && variant.dimensions.filter(function (dimension) {
    return dimension.measurements.length === 1;
  });
  var selectedDimensions = {};
  singleUnitDimensions === null || singleUnitDimensions === void 0 ? void 0 : singleUnitDimensions.forEach(function (dimension) {
    var firstAndOnlyMeasurement = dimension.measurements[0];
    selectedDimensions[dimension.label] = firstAndOnlyMeasurement;
  });
  return selectedDimensions;
};
/**
 * On variant change, keep only the dimension selections that are present in the new variant
 */


var getSelectedDimensions = function getSelectedDimensions(_a) {
  var _b;

  var variant = _a.variant,
      currentDimensions = _a.currentDimensions;
  var selectedDimensions = {};
  (_b = variant.dimensions) === null || _b === void 0 ? void 0 : _b.forEach(function (variantDimension) {
    if (currentDimensions[variantDimension.label] && variantDimension.measurements.includes(currentDimensions[variantDimension.label])) {
      selectedDimensions[variantDimension.label] = currentDimensions[variantDimension.label];
    }
  });
  return selectedDimensions;
};

function initQuickAddState(variants) {
  var selectedDimensions = setDefaultDimension({
    variant: variants[0]
  });
  return {
    selectedVariant: variants[0],
    selectedDimensions: selectedDimensions,
    outOfStockDimensions: getAllOutOfStockDimensions({
      variant: variants[0],
      selectedDimensions: selectedDimensions
    }),
    selectedSku: findSku({
      variant: variants[0],
      selectedDimensions: selectedDimensions
    }),
    inProgress: false,
    response: {},
    unselectedDimensions: '',
    variants: variants.map(function (variant) {
      return _assign(_assign({}, variant), {
        dimensions: variant.dimensions.map(function (d) {
          return _assign(_assign({}, d), {
            measurements: d.measurements.map(function (m) {
              return m;
            })
          });
        })
      });
    }),
    quantity: 1
  };
}

function quickAddReducer(state, action) {
  var _a;

  switch (action.type) {
    case VARIANT_CHANGE:
      {
        var variant_1 = action.payload.variant;
        var currentVariant = state.variants.filter(function (v) {
          return v.id === variant_1.id;
        })[0];
        variant_1.dimensions = currentVariant.dimensions.map(function (d) {
          return _assign(_assign({}, d), {
            measurements: d.measurements.map(function (m) {
              return m;
            })
          });
        });
        var selectedDimensions = getSelectedDimensions({
          variant: variant_1,
          currentDimensions: state.selectedDimensions
        });
        var selectedSku = findSku({
          variant: variant_1,
          selectedDimensions: selectedDimensions
        });
        var outOfStockDimensions = getAllOutOfStockDimensions({
          variant: variant_1,
          selectedDimensions: selectedDimensions
        });
        return _assign(_assign({}, state), {
          response: {},
          selectedDimensions: selectedDimensions,
          selectedVariant: getValidMeasurements({
            selectedDimensions: selectedDimensions,
            variant: variant_1
          }),
          outOfStockDimensions: outOfStockDimensions,
          selectedSku: selectedSku,
          unselectedDimensions: selectedSku ? '' : getUnselectedDimensionLabels({
            dimensions: variant_1.dimensions,
            selectedDimensions: selectedDimensions
          })
        });
      }

    case QUANTITY_CHANGE:
      return _assign(_assign({}, state), {
        quantity: action.payload.quantity,
        inProgress: false,
        response: {}
      });

    case DIMENSION_CHANGE:
      {
        var _b = action.payload,
            dimension = _b.dimension,
            measurement = _b.measurement;

        var selectedDimensions = _assign(_assign({}, state.selectedDimensions), (_a = {}, _a[dimension.label] = measurement, _a));

        var outOfStockDimensions = _assign(_assign({}, state.outOfStockDimensions), getAllOutOfStockDimensions({
          variant: state.selectedVariant,
          selectedDimensions: selectedDimensions
        }));

        var selectedSku = findSku({
          variant: state.selectedVariant,
          selectedDimensions: selectedDimensions
        });
        return _assign(_assign({}, state), {
          response: {},
          selectedDimensions: selectedDimensions,
          selectedVariant: getValidMeasurements({
            selectedDimensions: selectedDimensions,
            variant: state.variants.find(function (_a) {
              var id = _a.id;
              return id === state.selectedVariant.id;
            })
          }),
          selectedSku: selectedSku,
          outOfStockDimensions: outOfStockDimensions,
          unselectedDimensions: selectedSku ? '' : getUnselectedDimensionLabels({
            dimensions: state.selectedVariant.dimensions,
            selectedDimensions: selectedDimensions
          })
        });
      }

    case ADD_TO_BAG_SIZE_VALIDATION:
      return _assign(_assign({}, state), {
        unselectedDimensions: getUnselectedDimensionLabels({
          dimensions: state.selectedVariant.dimensions,
          selectedDimensions: state.selectedDimensions
        })
      });

    case ADD_TO_BAG_REQUEST:
      return _assign(_assign({}, state), {
        inProgress: true
      });

    case ADD_TO_BAG_RESPONSE:
      return _assign(_assign({}, state), {
        response: action.payload.response,
        inProgress: false
      });

    default:
      {
        return state;
      }
  }
}
/**
 * returns all valid sizes based on selection
 */


function getValidMeasurements(_a) {
  var selectedDimensions = _a.selectedDimensions,
      variant = _a.variant;

  if (Object.keys(selectedDimensions).length && variant.dimensions.length > 1) {
    var updatedVariant = _assign({}, variant);

    var validSku = variant.skus.filter(function (sku) {
      return sku.dimensions.find(function (_a) {
        var label = _a.label,
            measurement = _a.measurement;
        return selectedDimensions[label] && measurement === selectedDimensions[label];
      });
    });
    var dimensionsToUpdate_1 = {};
    Object.entries(selectedDimensions).forEach(function (_a) {
      var selectedLabel = _a[0];
      return variant.dimensions.filter(function (_a) {
        var label = _a.label;
        return label !== selectedLabel;
      }).forEach(function (_a) {
        var label = _a.label;
        dimensionsToUpdate_1[label] = new Set();
      });
    });
    validSku.forEach(function (sku) {
      sku.dimensions.forEach(function (_a) {
        var label = _a.label,
            measurement = _a.measurement;
        dimensionsToUpdate_1[label] && dimensionsToUpdate_1[label].add(measurement);
      });
    });
    updatedVariant.dimensions = variant.dimensions.map(function (_a) {
      var label = _a.label,
          measurements = _a.measurements;

      if (dimensionsToUpdate_1[label]) {
        var expectedMeasurements_1 = Array.from(dimensionsToUpdate_1[label]);
        return {
          label: label,
          measurements: measurements.filter(function (m) {
            return expectedMeasurements_1.includes(m);
          })
        };
      }

      return {
        label: label,
        measurements: measurements
      };
    });
    return updatedVariant;
  }

  return variant;
} // gets out of stock measurements for all dimensions other than the given dimension


function getOutOfStockMeasurements(_a) {
  var variant = _a.variant,
      dimension = _a.dimension,
      selectedMeasurement = _a.selectedMeasurement;
  var dimensionsToUpdate = Object.fromEntries(variant.dimensions.filter(function (d) {
    return d.label !== dimension.label;
  }).map(function (d) {
    return [d.label, new Set()];
  }));
  variant.skus.filter(function (sku) {
    var dimensionToCheck = sku.dimensions.find(function (d) {
      return d.label === dimension.label;
    });
    return dimensionToCheck && dimensionToCheck.measurement === selectedMeasurement && !sku.inStock;
  }).forEach(function (sku) {
    sku.dimensions.forEach(function (_a) {
      var label = _a.label,
          measurement = _a.measurement;
      dimensionsToUpdate[label] && dimensionsToUpdate[label].add(measurement);
    });
  });
  return dimensionsToUpdate;
}

function isMeasurementAvailableInAnySku(measurement, skus) {
  return skus.some(function (_a) {
    var inStock = _a.inStock,
        dimensions = _a.dimensions;
    return inStock && dimensions.some(function (d) {
      return d.measurement === measurement;
    });
  });
}

function getAllOutOfStockDimensions(_a) {
  var _b;

  var _c;

  var variant = _a.variant,
      selectedDimensions = _a.selectedDimensions;

  if (((_c = variant.dimensions) === null || _c === void 0 ? void 0 : _c.length) === 1) {
    return _b = {}, _b[variant.dimensions[0].label] = new Set(variant.dimensions[0].measurements.filter(function (m) {
      return !isMeasurementAvailableInAnySku(m, variant.skus);
    })), _b;
  }

  var outOfStock = {};
  Object.entries(selectedDimensions).forEach(function (_a) {
    var _b;

    var label = _a[0],
        measurement = _a[1];
    outOfStock = _assign(_assign({}, outOfStock), getOutOfStockMeasurements({
      variant: variant,
      dimension: (_b = variant.dimensions) === null || _b === void 0 ? void 0 : _b.find(function (d) {
        return d.label === label;
      }),
      selectedMeasurement: measurement
    }));
  });
  return outOfStock;
}

function findSku(_a) {
  var _b;

  var variant = _a.variant,
      selectedDimensions = _a.selectedDimensions;
  return ((_b = variant.skus) === null || _b === void 0 ? void 0 : _b.find(function (sku) {
    var _a;

    return sku.inStock && ((_a = sku.dimensions) === null || _a === void 0 ? void 0 : _a.length) && sku.dimensions.every(function (_a) {
      var label = _a.label,
          measurement = _a.measurement;
      return measurement === selectedDimensions[label];
    });
  })) || null;
}

function getUnselectedDimensionLabels(_a) {
  var dimensions = _a.dimensions,
      selectedDimensions = _a.selectedDimensions;
  return dimensions.filter(function (dimension) {
    return !selectedDimensions[dimension.label];
  }).map(function (_a) {
    var label = _a.label;
    return label;
  }).join(' & ').toLowerCase();
}

var isMergedVariant = function isMergedVariant(variant) {
  return !!variant.link;
};

var getRegularVariants = function getRegularVariants(variants) {
  var isRegularVariant = function isRegularVariant(variant) {
    return !isMergedVariant(variant);
  };

  return variants.filter(isRegularVariant);
};

function isVariantInStock(_a) {
  var inStock = _a.inStock;
  return inStock || typeof inStock === 'undefined';
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign$2 = function __assign$2() {
  _assign$2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$2.apply(this, arguments);
};

function __rest$1(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var checkForServerErrors = function checkForServerErrors(response) {
  return response.networkErrorCode ? {
    errorCode: response.networkErrorCode,
    moreInfo: response.networkError || 'Network Error'
  } : null;
};

var checkForInlineBagErrors = function checkForInlineBagErrors(response) {
  var _a = response.inlineBagModelData || {},
      bagError = _a.bagError,
      errorAddToBag = _a.errorAddToBag;

  if (bagError || errorAddToBag) {
    return {
      errorCode: 200,
      moreInfo: (bagError === null || bagError === void 0 ? void 0 : bagError.errorMsg) || (errorAddToBag === null || errorAddToBag === void 0 ? void 0 : errorAddToBag.errorMsg) || 'Unknown bag error returned from server'
    };
  }

  return null;
};

var checkForBagErrors = function checkForBagErrors(response) {
  var _a = response.inlineBagModelData || {},
      subTotal = _a.subTotal,
      itemCount = _a.itemCount;

  var bagErrors = !subTotal ? 'Bag subtotal not set' : 'Bag itemCount not set';

  if (!(subTotal && itemCount)) {
    return {
      errorCode: 200,
      moreInfo: bagErrors
    };
  }

  return null;
};

var normalizeLegacyResponse = function normalizeLegacyResponse(response) {
  var serverErrors = checkForServerErrors(response);
  var inlineBagErrors = checkForInlineBagErrors(response);
  var bagErrors = checkForBagErrors(response);

  if (serverErrors || inlineBagErrors || bagErrors) {
    var errors = [serverErrors, inlineBagErrors, bagErrors];
    return {
      status: 'ERROR',
      errors: errors.filter(function (err) {
        return !!err;
      })
    };
  }

  var inlineBagModelData = response.inlineBagModelData;
  var itemCount = inlineBagModelData.itemCount,
      inlineBagItems = inlineBagModelData.inlineBagItems,
      subTotal = inlineBagModelData.subTotal;
  var _a = inlineBagItems[0].itemSubtotal,
      itemSubtotal = _a === void 0 ? '' : _a;
  return {
    inlineBagModelData: inlineBagModelData,
    itemCount: itemCount,
    itemSubtotal: itemSubtotal,
    subTotal: subTotal,
    status: 'SUCCESS'
  };
};

var catchHttpError = function catchHttpError(response) {
  if (response.ok) {
    return response;
  }

  var contentType = response.headers.get('content-type');
  var jsonType = 'application/json';

  if (contentType.startsWith(jsonType)) {
    return response.json().then(function (err) {
      throw _assign$2(_assign$2({}, err), {
        status: response.status
      });
    });
  }

  return response.text().then(function (err) {
    throw new Error("" + (response.status || err));
  });
};

var addToBagBrandCodes = {
  gap: 'GP',
  br: 'BR',
  on: 'ON',
  at: 'AT',
  gapfs: 'GPFS',
  brfs: 'BRFS'
};

var legacyRequestBuilder = function legacyRequestBuilder(_a) {
  var skuId = _a.skuId,
      _b = _a.quantity,
      quantity = _b === void 0 ? '1' : _b,
      cid = _a.cid;
  var queryParams = "?skuid=" + skuId + "&quantity" + skuId + "=" + quantity + "&sfl" + skuId + "=false";
  return cid ? queryParams + "&cid" + skuId + "=" + cid : queryParams + "&cid" + skuId;
};

var leapfrogRequestBuilder = function leapfrogRequestBuilder(_a) {
  var skuId = _a.skuId,
      _b = _a.quantity,
      quantity = _b === void 0 ? 1 : _b;
  return {
    sku: skuId,
    quantity: quantity
  };
};
/**
 * Adds a custom formatter for add to bag as leapfrog service sends raw price
 * and generic currency formatter from core-ui would not be suffice PDP currency formats
 *
 * Uses translations to convert raw price to corresponding currency
 * coverts as below
 * en_US -  12 -> $12.00,       34.99 -> $34.99
 * en_CA -  12 -> $CA12.00,     34.99 -> $CA34.99
 * fr_CA -  12 -> 12,00 $ CA,   34.99 -> 34,99  $ CA
 */


var formatPriceByLocaleSwitch = function formatPriceByLocaleSwitch(price, locale) {
  return {
    en_US: "$" + price,
    en_CA: "CA$" + price,
    fr_CA: price + " $ CA",
    default: price
  }[locale];
};

var currencyFormatter = function currencyFormatter(locale) {
  if (locale === void 0) {
    locale = 'en_US';
  }

  var formatter = function formatter(price) {
    if (price === void 0) {
      price = 0;
    }

    var correctedPrice = locale === 'fr_CA' ? price.toFixed(2).replace(/\./g, ',') : price.toFixed(2);
    return formatPriceByLocaleSwitch(correctedPrice, locale) || formatPriceByLocaleSwitch(correctedPrice, 'default');
  };

  return formatter;
};

var en_US = {
  "addToBag.outOfStock": "We're sorry, the item in the size and color you wish to add to bag just sold out. Other selections may be available.",
  "addToBag.genericError": "We are sorry, there has been an error adding this item to bag.",
  "addToBag.maxLineItemLimitReached": "You have added the maximum number of items to your Shopping Bag. Make room in your bag by removing unwanted items, or place your order now.",
  "addToBag.maxQuantityReached": "We're sorry, but only {{maxQuantityAllowed}} {{name}} may be purchased in one order.",
  "addToBag.partialSuccess": "Only {{quantityAdded}} items are in stock at this time and have been added to your bag. We apologize for the inconvenience."
};
var en_CA = {
  "addToBag.outOfStock": "We're sorry, the item in the size and color you wish to add to bag just sold out. Other selections may be available.",
  "addToBag.genericError": "We are sorry, there has been an error adding this item to bag.",
  "addToBag.maxLineItemLimitReached": "You have added the maximum number of items to your Shopping Bag. Make room in your bag by removing unwanted items, or place your order now.",
  "addToBag.maxQuantityReached": "We're sorry, but only {{maxQuantityAllowed}} {{name}} may be purchased in one order.",
  "addToBag.partialSuccess": "Only {{quantityAdded}} items are in stock at this time and have been added to your bag. We apologize for the inconvenience."
};
var fr_CA = {
  "addToBag.outOfStock": "Veuillez nous excuser, l`article que vous désirez ajouter à votre panier n`est plus disponible dans la taille et la couleur demandées. Veuillez faire un autre choix.",
  "addToBag.genericError": "Veuillez nous excuser, une erreur s`est produite lors de l`ajout de cet article à votre panier.",
  "addToBag.maxLineItemLimitReached": "Vous avez ajouté le numéro maximum d`articles à votre panier. Faites de l`espace dans votre panier en enlevant les articles non désirés ou passez votre commande dès maintenant.",
  "addToBag.maxQuantityReached": "Nous sommes désolés, mais {{maxQuantityAllowed}} {{name}} uniquement peuvent être achetés par commande.",
  "addToBag.partialSuccess": "Seulement {{quantityAdded}} articles sont en stock actuellement et ont été ajoutés à votre panier. Nous nous excusons de tout inconvénient occasionné."
};
var config = {
  en_US: en_US,
  en_CA: en_CA,
  fr_CA: fr_CA
};

function translationsConfig(locale) {
  return config[locale];
}

var _a;

var OUT_OF_STOCK_ERR = 'BAGCAT-4010';
var MAX_QUANTITY_LIMIT_ERR = 'BAGCAT-8007';
var PARTIAL_SUCCESS_ERR = 'BAGICM-3070';
var BOPIS_RESERVE_FAIL = 'BAGICM-3000';
var MAX_LINE_ITEM_ERR = 'BAGAPI-2060';
var DEFAULT_BAG_ERROR = 'default';
var responseConfig = (_a = {}, _a[OUT_OF_STOCK_ERR] = 'addToBag.outOfStock', _a[PARTIAL_SUCCESS_ERR] = 'addToBag.partialSuccess', _a[MAX_QUANTITY_LIMIT_ERR] = 'addToBag.maxQuantityReached', _a[MAX_LINE_ITEM_ERR] = 'addToBag.maxLineItemLimitReached', _a[BOPIS_RESERVE_FAIL] = 'addToBag.outOfStock', _a[DEFAULT_BAG_ERROR] = 'addToBag.genericError', _a);

function getTranslations(locale) {
  var config = translationsConfig(locale || 'en_US');

  function translations(_a) {
    var errorCode = _a.errorCode,
        args = __rest$1(_a, ["errorCode"]);

    if (responseConfig[errorCode]) {
      var translationsKey_1 = responseConfig[errorCode];
      var translations_1 = config[translationsKey_1];
      Object.keys(args).forEach(function (key) {
        translations_1 = translations_1.replace("{{" + key + "}}", args[key]);
      });
      return translations_1;
    }

    var translationsKey = responseConfig[DEFAULT_BAG_ERROR];
    return config[translationsKey];
  }

  return translations;
}

var leapfrogResponseFormatter = function leapfrogResponseFormatter(_a) {
  var locale = _a.locale,
      response = _a.response,
      actualQuantity = _a.actualQuantity,
      sku = _a.sku;

  if (response.errorCode || !response.items || !response.items.length) {
    var translations = getTranslations(locale);
    return {
      status: 'ERROR',
      errors: [{
        moreInfo: translations({
          errorCode: response.errorCode
        }),
        errorCode: response.errorCode
      }]
    };
  }

  var getLocalizedPrice = function getLocalizedPrice(locale) {
    return currencyFormatter(locale);
  };

  var formatCurrency = getLocalizedPrice(locale);
  var subTotal = response.charges.subTotal,
      productPrice = response.items[0].productPrice,
      productData = response.productData,
      totalBagQuantity = response.totalBagQuantity;
  var _b = productData[0],
      color = _b.color,
      eligibleReturnLocationCode = _b.eligibleReturnLocationCode,
      inventoryStatusId = _b.inventoryStatusId,
      priceTypeId = _b.priceTypeId,
      productImage = _b.productImage,
      productStyleDescription = _b.productStyleDescription,
      productURL = _b.productURL,
      size = _b.size,
      styleNumber = _b.styleNumber;
  var formattedResponse = {
    subTotal: formatCurrency(subTotal),
    itemCount: totalBagQuantity,
    status: 'SUCCESS',
    itemSubtotal: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
    inlineBagModelData: {
      inlineBagItems: [{
        colorDescription: color,
        inventoryLevel: inventoryStatusId,
        itemSubtotal: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
        listPrice: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.regularPrice),
        productLink: "/" + productURL,
        quantity: actualQuantity,
        returnType: eligibleReturnLocationCode,
        sellPrice: formatCurrency(productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
        shouldShowSalePrice: (productPrice === null || productPrice === void 0 ? void 0 : productPrice.regularPrice) !== (productPrice === null || productPrice === void 0 ? void 0 : productPrice.salePrice),
        siImageURI: productImage === null || productImage === void 0 ? void 0 : productImage.summaryImagePath,
        sku: sku,
        skuDescription: size,
        styleDescription: productStyleDescription,
        priceType: priceTypeId,
        styleId: styleNumber
      }]
    }
  };
  return formattedResponse;
};

var LEAP_FROG_ADD_TO_BAG_URL = '/commerce/shopping-bags/';

var requestHeader = function requestHeader(_a) {
  var _b = _a.clientId,
      clientId = _b === void 0 ? 'PDP' : _b,
      market = _a.market,
      brand = _a.brand,
      _c = _a.oidcUrl,
      oidcUrl = _c === void 0 ? '' : _c;
  var headers = {
    market: market,
    brand: brand,
    channel: 'WEB',
    'X-Gap-ApiMode': 'leapfrog',
    'Content-Type': 'application/json',
    clientId: clientId
  };
  var previewRegExp = /(\.wip)|(\.app)/;
  var previewEnv = (previewRegExp.exec(oidcUrl) || [null])[0];

  if (previewEnv) {
    return _assign$2(_assign$2({}, headers), {
      previewType: previewEnv === '.wip' ? 'WIP' : 'APR'
    });
  }

  return headers;
};

var updateBag = function updateBag(_a) {
  var brand = _a.brand,
      clientId = _a.clientId,
      items = _a.items,
      locale = _a.locale,
      market = _a.market,
      name = _a.name,
      oidcUrl = _a.oidcUrl,
      shoppingBagId = _a.shoppingBagId;
  return __awaiter(void 0, void 0, void 0, function () {
    var url, _b, sku, quantity, data, translations, headers;

    return __generator(this, function (_c) {
      url = !shoppingBagId ? "" + oidcUrl + LEAP_FROG_ADD_TO_BAG_URL + "items/summary?locale=" + locale : "" + oidcUrl + LEAP_FROG_ADD_TO_BAG_URL + shoppingBagId + "/items/summary?locale=" + locale;
      _b = items[0], sku = _b.sku, quantity = _b.quantity;
      data = {
        market: market,
        brand: brand,
        partialReservation: true,
        items: items
      };
      translations = getTranslations(locale);
      headers = requestHeader({
        brand: brand,
        clientId: clientId,
        market: market,
        oidcUrl: oidcUrl
      });
      return [2
      /*return*/
      , fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(data)
      }).then(catchHttpError).then(function (response) {
        return response.json();
      }).then(function (response) {
        var _a;

        var _b = response.items,
            _c = _b === void 0 ? [{}] : _b,
            maxQuantityAllowed = _c[0].maxQuantityAllowed,
            _d = response.itemErrors,
            _e = _d === void 0 ? [{
          errorCode: null
        }] : _d,
            errorCode = _e[0].errorCode,
            _f = response.outOfStockItems,
            outOfStockItems = _f === void 0 ? [] : _f;

        var mainError = response.errorCode;
        /**
         * In some cases, when there is a promotion added to certain products, multiple line items can be present
         * In those scenarios, total of addedQuantity in individual line item reflects the total added quantity.
         */

        var addedQuantity = (_a = response.items) === null || _a === void 0 ? void 0 : _a.reduce(function (sum, item) {
          return sum + item.addedQuantity;
        }, 0);
        var completeSuccess = !mainError && !errorCode && !outOfStockItems.length;
        var partialSuccess = errorCode === PARTIAL_SUCCESS_ERR; // if add to bag is at least partial success, then process the response data

        if ((completeSuccess || partialSuccess) && response.productData) {
          var actualQuantity = completeSuccess ? quantity : addedQuantity;
          var warnings = completeSuccess ? null : {
            errorCode: errorCode,
            partialSuccess: true,
            addedQuantity: addedQuantity,
            message: translations({
              errorCode: errorCode || mainError,
              quantityAdded: addedQuantity
            })
          };
          var formattedResponse = leapfrogResponseFormatter({
            locale: locale,
            response: response,
            actualQuantity: actualQuantity,
            sku: sku
          });
          return _assign$2(_assign$2({}, formattedResponse), {
            warnings: warnings
          });
        }

        var decodedName = he.decode(name);
        var moreInfo = errorCode === MAX_QUANTITY_LIMIT_ERR ? translations({
          errorCode: errorCode,
          maxQuantityAllowed: maxQuantityAllowed,
          name: decodedName
        }) : translations({
          errorCode: errorCode || mainError
        });
        return {
          status: 'ERROR',
          errors: [{
            errorCode: errorCode || mainError,
            moreInfo: moreInfo
          }]
        };
      }).catch(function (err) {
        var _a, _b, _c, _d;

        var errorCode = ((_b = (_a = err === null || err === void 0 ? void 0 : err.itemErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.errorCode) || (err === null || err === void 0 ? void 0 : err.errorCode) || (err === null || err === void 0 ? void 0 : err.status) || err; // Special scenario where leapfrog service returns error code as partial success
        // when ICM returns OOS and we have to treat it as regular out of stock scenario

        if (errorCode === PARTIAL_SUCCESS_ERR) {
          errorCode = OUT_OF_STOCK_ERR;
        }

        if (errorCode === MAX_QUANTITY_LIMIT_ERR) {
          var decodedName = he.decode(name);
          var maxQuantityAllowed = (_d = (_c = err === null || err === void 0 ? void 0 : err.itemErrors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.maxQuantityAllowed;
          var moreInfo = translations({
            errorCode: errorCode,
            maxQuantityAllowed: maxQuantityAllowed,
            name: decodedName
          });
          return {
            status: 'ERROR',
            errors: [{
              errorCode: errorCode,
              moreInfo: moreInfo
            }]
          };
        }

        return {
          status: 'ERROR',
          errors: [{
            errorCode: errorCode || DEFAULT_BAG_ERROR,
            moreInfo: translations({
              errorCode: errorCode
            }),
            developerMessage: "Add to Bag - " + ((err === null || err === void 0 ? void 0 : err.userMessage) || err && _typeof(err) === 'object' && JSON.stringify(err) || err)
          }]
        };
      })];
    });
  });
};

var defaultConfig = {
  credentials: 'include'
};

function addToBag(_a) {
  var brand = _a.brand,
      clientId = _a.clientId,
      items = _a.items,
      locale = _a.locale,
      market = _a.market,
      name = _a.name,
      oidcUrl = _a.oidcUrl,
      shoppingBagId = _a.shoppingBagId;
  return __awaiter(this, void 0, void 0, function () {
    var brandCode, marketCode, data;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          brandCode = addToBagBrandCodes[brand];
          marketCode = market.toUpperCase();
          return [4
          /*yield*/
          , updateBag({
            brand: brandCode,
            clientId: clientId,
            items: items,
            locale: locale,
            market: marketCode,
            name: name,
            oidcUrl: oidcUrl,
            shoppingBagId: shoppingBagId
          })];

        case 1:
          data = _b.sent();
          return [2
          /*return*/
          , data];
      }
    });
  });
}
/**
 * Legacy Add to Bag Service
 * @param baseUrl
 * @param queryString must have skuId quantity, sfl and cid
 */


function addToBagLegacyRequest(_a) {
  var baseUrl = _a.baseUrl,
      queryString = _a.queryString;
  var url = baseUrl + "/buy/inlineShoppingBagAddJson.do" + queryString;
  return fetch(url, defaultConfig).then(catchHttpError).then(function (response) {
    return response.json();
  }).then(normalizeLegacyResponse).catch(function (err) {
    return {
      status: 'ERROR',
      errors: [{
        moreInfo: err.message || 'Network Error',
        errorCode: err.message
      }]
    };
  });
}

var priceFormat = /[\d|,]+\.*[\d|,]*/;
var stripEventFormat = /event\d+=/;

var toNumeric = function toNumeric(str) {
  return parseFloat(((str.replace(stripEventFormat, '').match(priceFormat) || [])[0] || '0.00').replace(',', ''));
};

var extractPrice = function extractPrice(str) {
  if (!str) return '';
  return toNumeric(str).toFixed(2);
};

var addToBagReportingDataBuilder = function addToBagReportingDataBuilder(_a) {
  var _b = _a.name,
      name = _b === void 0 ? '' : _b,
      price = _a.price,
      _c = _a.quantity,
      quantity = _c === void 0 ? 1 : _c,
      _d = _a.sku,
      sku = _d === void 0 ? '' : _d,
      _e = _a.itemSubtotal,
      itemSubtotal = _e === void 0 ? '' : _e,
      _f = _a.pid,
      pid = _f === void 0 ? '' : _f,
      _g = _a.selectedSize,
      selectedSize = _g === void 0 ? '' : _g;
  var _h = price.rawRegularPrice,
      listPrice = _h === void 0 ? 0 : _h,
      _j = price.rawCurrentPrice,
      soldPrice = _j === void 0 ? 0 : _j,
      _k = price.localizedCurrentPrice,
      localizedPrice = _k === void 0 ? '' : _k;
  var markDownAmount = ((listPrice - soldPrice) * quantity).toFixed(2);
  var productGrossMerchandise = extractPrice(itemSubtotal);
  return {
    product_gross_merchandise: [productGrossMerchandise],
    product_id: [pid.slice(0, 6)],
    product_inventory_status: true,
    product_markdown_amount: [markDownAmount],
    product_name: [name],
    product_price: ["" + localizedPrice],
    product_quantity: ["" + quantity],
    product_sku: [sku],
    product_selected_size: [selectedSize]
  };
};

var AddToBagButton = function AddToBagButton(_a) {
  var onClick = _a.onClick,
      styles = _a.styles,
      children = _a.children,
      otherProps = __rest$1(_a, ["onClick", "styles", "children"]);

  return jsx(ComposableButton, _assign$2({}, otherProps, {
    css: styles,
    onClick: onClick
  }), children);
};

var backOrderNotificationStyles = function backOrderNotificationStyles(theme) {
  return css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    ", "\n    line-height: 1.25;\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    position: relative;\n    color: inherit;\n    border-color: #5cabf7;\n    font-weight: 400;\n    font-size: 0.875rem;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(\"data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1.315 8.533h-2.63v7.256h2.63V8.533zM9.996 4.21c-.903 0-1.575.621-1.575 1.449 0 .833.67 1.456 1.575 1.456.906 0 1.583-.624 1.583-1.456 0-.828-.679-1.45-1.583-1.45z' fill='%235CABF7' /%3E%3C/svg%3E\")\n        no-repeat;\n    }\n  "], ["\n    ", "\n    line-height: 1.25;\n    padding: 0.625rem 2rem 0.625rem 2.2rem;\n    margin-bottom: 1.125rem;\n    border-width: 2px 2px 2px 8px;\n    border-style: solid;\n    position: relative;\n    color: inherit;\n    border-color: #5cabf7;\n    font-weight: 400;\n    font-size: 0.875rem;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0.5rem;\n      height: 1.25rem;\n      width: 1.25rem;\n      transform: translateY(-50%);\n      background: url(\"data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1.315 8.533h-2.63v7.256h2.63V8.533zM9.996 4.21c-.903 0-1.575.621-1.575 1.449 0 .833.67 1.456 1.575 1.456.906 0 1.583-.624 1.583-1.456 0-.828-.679-1.45-1.583-1.45z' fill='%235CABF7' /%3E%3C/svg%3E\")\n        no-repeat;\n    }\n  "])), sdsBodyA(theme));
};

var templateObject_1$a;
/** @jsx jsx */

dayjs.extend(utc);

var formatDate = function formatDate(str) {
  return dayjs.utc(str).format('MMMM D, YYYY');
};

function BackOrderMessaging(_a) {
  var selectedSku = _a.selectedSku;
  var localize = useLocalize().localize;
  var date = formatDate(selectedSku.backOrderDate);
  var message = localize('quickAdd.onBackOrderMessage', {
    date: date
  });
  var ariaLabel = localize('quickAdd.onBackOrderMessage.ariaLabel', {
    date: date
  });
  return jsx("div", {
    "aria-label": ariaLabel,
    "aria-live": "polite",
    className: "quick-add__backorder-messaging",
    css: backOrderNotificationStyles,
    role: "alert"
  }, jsx("span", {
    "aria-hidden": "true"
  }, message));
}

function PriceLabel(_a) {
  var price = _a.price;
  var localize = useLocalize().localize;
  var currentPrice = price.rawCurrentPrice,
      regularPrice = price.rawRegularPrice;
  var isSalePrice = currentPrice < regularPrice;
  var isCurrentPriceHigherThanRegular = currentPrice > regularPrice;

  var getAriaLabel = function getAriaLabel() {
    return isSalePrice ? localize('pdp.price.regularPriceAriaLabel', {
      price: price.localizedRegularPrice
    }) : '';
  };

  var priceCrossedClassNames = classnames({
    'regular-price__line-through': isSalePrice
  });
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "regular-price__pipe"
  }, "|"), /*#__PURE__*/React.createElement("div", {
    "aria-label": getAriaLabel(),
    className: "regular-price"
  }, isSalePrice && /*#__PURE__*/React.createElement("span", null, price.localizedCurrentPrice), /*#__PURE__*/React.createElement("span", {
    className: priceCrossedClassNames
  }, isCurrentPriceHigherThanRegular ? price.localizedCurrentPrice : price.localizedRegularPrice)));
}

var ErrorMessage = function ErrorMessage(_a) {
  var error = _a.error;
  return error && error !== '' && jsx("div", {
    "aria-live": "polite",
    css: errorStyles,
    role: "alert"
  }, error);
};

var updateBagCount = function updateBagCount(selectedSku, currentBagItemCount) {
  var itemsToAdd = parseInt(selectedSku.quantity, 10) || 1;
  var updateBagEvent = new CustomEvent('updateBagCount', {
    detail: {
      quantity: (currentBagItemCount || 0) + itemsToAdd
    }
  });
  document.dispatchEvent(updateBagEvent);
};

var getButtonAnimationStatus = function getButtonAnimationStatus(inProgress, response) {
  var _a, _b;

  if (inProgress) {
    return AnimationStatus.Loading;
  }

  if ((response === null || response === void 0 ? void 0 : response.status) === 'SUCCESS' && !((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length)) {
    return AnimationStatus.Success;
  }

  if ((response === null || response === void 0 ? void 0 : response.status) === 'ERROR' || (response === null || response === void 0 ? void 0 : response.status) === 'FAILURE' || ((_b = response === null || response === void 0 ? void 0 : response.errors) === null || _b === void 0 ? void 0 : _b.length)) {
    return AnimationStatus.Failure;
  }

  return AnimationStatus.None;
};

var getButtonLabel = function getButtonLabel(selectedSku, inProgress, buttonLabels) {
  if (selectedSku && inProgress) {
    return '';
  }

  if (selectedSku) {
    return buttonLabels.addItemToBag;
  }

  if (!selectedSku) {
    return buttonLabels.selectASize;
  }

  return '';
};

var getRequestInfo = function getRequestInfo(_a) {
  var addToBagUrls = _a.addToBagUrls,
      brand = _a.brand,
      _b = _a.clientId,
      clientId = _b === void 0 ? 'QuickAdd' : _b,
      enableLegacyAddToBag = _a.enableLegacyAddToBag,
      locale = _a.locale,
      market = _a.market,
      name = _a.name,
      selectedSku = _a.selectedSku,
      unknownShopperId = _a.unknownShopperId;

  var _c = selectedSku || {},
      skuId = _c.skuId,
      _d = _c.quantity,
      quantity = _d === void 0 ? '1' : _d;

  var legacyUrl = addToBagUrls.secureUrl,
      oidcUrl = addToBagUrls.oidcUrl;

  if (enableLegacyAddToBag) {
    var queryString = legacyRequestBuilder({
      skuId: skuId,
      quantity: quantity
    });
    return {
      request: addToBagLegacyRequest({
        baseUrl: legacyUrl,
        queryString: queryString
      })
    };
  }

  var item = leapfrogRequestBuilder({
    skuId: skuId,
    quantity: parseInt(quantity, 10) || 1
  });
  return {
    request: addToBag({
      brand: brand,
      clientId: clientId,
      items: [_assign({}, item)],
      locale: locale,
      market: market,
      name: name,
      oidcUrl: oidcUrl,
      shoppingBagId: unknownShopperId
    })
  };
};

var getAddToBagErrors = function getAddToBagErrors(response, clientId, errorLogger) {
  var _a;

  return (_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.map(function (err, i) {
    errorLogger(new Error("[ERROR] " + clientId + " QuickAdd Error message: " + err.moreInfo + " "));
    return (err.developerMessage || err.moreInfo) && jsx(ErrorMessage, {
      key: "add-to-bag-error-" + i.toString(),
      error: err.moreInfo
    });
  });
};

var getButtonLabels = function getButtonLabels(labels, localize) {
  return {
    selectASize: (labels === null || labels === void 0 ? void 0 : labels.selectASize) || localize('quickAdd.selectASize'),
    addItemToBag: (labels === null || labels === void 0 ? void 0 : labels.addItemToBag) || localize('quickAdd.addToBag'),
    addToBagInProgress: (labels === null || labels === void 0 ? void 0 : labels.addToBagInProgress) || '',
    addToBagSuccess: (labels === null || labels === void 0 ? void 0 : labels.addToBagSuccess) || localize('quickAdd.addToBagSuccess'),
    addToBagFailure: (labels === null || labels === void 0 ? void 0 : labels.addToBagFailure) || localize('quickAdd.addToBagFailure')
  };
};

var getSizeSelectionMessage = function getSizeSelectionMessage(showError, unselectedDimensions, localize) {
  return showError && unselectedDimensions && unselectedDimensions !== '' ? jsx(ErrorMessage, {
    error: localize('quickAdd.error.sizeSelection', {
      unselectedDimensions: unselectedDimensions
    })
  }) : null;
};

function AddToBag(_a) {
  var addToBagUrls = _a.addToBagUrls,
      clientId = _a.clientId,
      dispatch = _a.dispatch,
      enableLegacyAddToBag = _a.enableLegacyAddToBag,
      inProgress = _a.inProgress,
      labels = _a.labels,
      name = _a.name,
      onAddToBag = _a.onAddToBag,
      price = _a.price,
      pid = _a.pid,
      response = _a.response,
      selectedSku = _a.selectedSku,
      _b = _a.selectedDimensions,
      selectedDimensions = _b === void 0 ? {} : _b,
      unselectedDimensions = _a.unselectedDimensions,
      errorLogger = _a.errorLogger,
      htmlProps = __rest(_a, ["addToBagUrls", "clientId", "dispatch", "enableLegacyAddToBag", "inProgress", "labels", "name", "onAddToBag", "price", "pid", "response", "selectedSku", "selectedDimensions", "unselectedDimensions", "errorLogger"]);

  var localize = useLocalize().localize;

  var _c = useState(false),
      showError = _c[0],
      setShowError = _c[1];

  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;

  var _d = useAppState$1(),
      brandName = _d.brandName,
      market = _d.market,
      locale = _d.locale;

  var _e = useContext(PersonalizationContext) || {},
      unknownShopperId = _e.customerUUID,
      shoppingBag = _e.shoppingBag;

  var buttonLabels = getButtonLabels(labels, localize);
  var successMessage = buttonLabels.addToBagSuccess;
  var failureMessage = buttonLabels.addToBagFailure;
  var addToBagErrors = getAddToBagErrors(response, clientId, errorLogger);
  var addToBagClasses = classnames('quick-add add-to-bag', {
    'add-to-bag--disabled': !selectedSku
  });
  var brFontFeatureFlag = ['br', 'brfs'].includes(brandName) ? 'enable-new-br-fonts' : '';
  var brFontEnabled = enabledFeatures[brFontFeatureFlag];
  var disableShoppingBagId = enabledFeatures['pdp-leapfrog-remove-shoppingBagId'];
  var sizeSelectionError = getSizeSelectionMessage(showError, unselectedDimensions, localize);

  var onButtonClick = function onButtonClick() {
    var _a;

    if (!enableLegacyAddToBag && !unknownShopperId && !disableShoppingBagId || ((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length)) {
      return;
    }

    if (!selectedSku) {
      setShowError(true);
      dispatch({
        type: ADD_TO_BAG_SIZE_VALIDATION
      });
      return;
    }

    setShowError(false);
    dispatch({
      type: ADD_TO_BAG_REQUEST
    });
    var request = getRequestInfo({
      addToBagUrls: addToBagUrls,
      brand: brandName,
      clientId: clientId,
      enableLegacyAddToBag: enableLegacyAddToBag,
      locale: locale,
      market: market,
      name: name,
      selectedSku: selectedSku,
      unknownShopperId: disableShoppingBagId ? null : unknownShopperId
    }).request;
    var _b = (selectedSku || {}).quantity,
        quantity = _b === void 0 ? '1' : _b;
    request.then(function (processedResponse) {
      var _a;

      var itemSubtotal = processedResponse.itemSubtotal || '';
      var selectedSize = selectedDimensions ? Object.values(selectedDimensions).join(' ') : '';
      var reportingData = addToBagReportingDataBuilder({
        sku: selectedSku.skuId,
        price: price,
        name: name,
        pid: pid,
        itemSubtotal: itemSubtotal,
        selectedSize: selectedSize,
        quantity: parseInt(quantity, 10)
      });
      onAddToBag === null || onAddToBag === void 0 ? void 0 : onAddToBag(processedResponse, reportingData);
      var success = (processedResponse === null || processedResponse === void 0 ? void 0 : processedResponse.status) === 'SUCCESS' && !((_a = processedResponse === null || processedResponse === void 0 ? void 0 : processedResponse.errors) === null || _a === void 0 ? void 0 : _a.length);

      if (success) {
        updateBagCount(selectedSku, shoppingBag === null || shoppingBag === void 0 ? void 0 : shoppingBag.totalItemCount);
      }

      dispatch({
        type: ADD_TO_BAG_RESPONSE,
        payload: {
          response: processedResponse
        }
      });
    });
  };

  return jsx(QuickAddContext.Consumer, null, function (_a) {
    var _b = _a.styles,
        styles = _b === void 0 ? {} : _b,
        quickAddVersion = _a.quickAddVersion;
    var _c = styles.addToBagButtonStyles,
        addToBagButtonStyles = _c === void 0 ? function () {
      return '';
    } : _c;
    var isProductInfoVersion = quickAddVersion === WITH_PRODUCT_INFO_VERSION;
    return jsx("div", null, sizeSelectionError, addToBagErrors, isProductInfoVersion && !!(selectedSku === null || selectedSku === void 0 ? void 0 : selectedSku.backOrderDate) && jsx(BackOrderMessaging, {
      selectedSku: selectedSku
    }), jsx(AddToBagButton, _assign({
      animationStatus: getButtonAnimationStatus(inProgress, response),
      capitalization: Capitalization.uppercase,
      className: "" + addToBagClasses,
      failureMessage: failureMessage,
      fullWidth: true,
      onClick: onButtonClick,
      roundedCorners: true,
      styles: function styles(theme) {
        return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n                  ", "\n                "], ["\n                  ", "\n                "])), addToBagButtonStyles(theme, brFontEnabled));
      },
      successMessage: successMessage
    }, htmlProps), jsx("span", null, getButtonLabel(selectedSku, inProgress, buttonLabels)), isProductInfoVersion && selectedSku && jsx(PriceLabel, {
      price: price
    })));
  });
}

var templateObject_1$b;

function DimensionGroups(_a) {
  var dimensions = _a.dimensions,
      selectedDimensions = _a.selectedDimensions,
      outOfStockDimensions = _a.outOfStockDimensions,
      dispatch = _a.dispatch,
      pid = _a.pid;
  var brandName = useAppState$1().brandName;
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var gothamFontEnabled = enabledFeatures["enable-" + brandName + "-gotham-font"];
  var brFontFeatureFlag = ['br', 'brfs'].includes(brandName) ? 'enable-new-br-fonts' : '';
  var brFontEnabled = enabledFeatures[brFontFeatureFlag];
  return jsx(QuickAddContext.Consumer, null, function (_a) {
    var styles = _a.styles;
    var dimensionGroupsContainerStyles = styles.dimensionGroupsContainerStyles,
        radioGroupStyles = styles.radioGroupStyles,
        dimensionRadioStyles = styles.dimensionRadioStyles;
    return jsx("div", {
      css: dimensionGroupsContainerStyles
    }, dimensions.map(function (dimension) {
      var label = dimension.label;
      return jsx("div", {
        key: label,
        "aria-labelledby": label + "-group",
        className: "radio-container radio-container--dimension",
        css: function css$1(theme) {
          return css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n                      ", "\n                    "], ["\n                      ", "\n                    "])), radioGroupStyles(theme, gothamFontEnabled, brFontEnabled));
        },
        role: "radiogroup"
      }, jsx("span", {
        className: "radio-container__label",
        id: label + "-group"
      }, label, jsx("span", {
        "aria-hidden": "true"
      }, ":")), jsx("div", {
        className: "dimension-group"
      }, dimension.measurements.map(function (measurement) {
        var _a;

        return jsx(DimensionRadio, {
          key: measurement,
          css: function css$1(theme) {
            return css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n                            ", "\n                          "], ["\n                            ", "\n                          "])), dimensionRadioStyles(theme, gothamFontEnabled));
          },
          id: pid + "-" + label + "-" + measurement,
          inStock: !((_a = outOfStockDimensions[dimension.label]) === null || _a === void 0 ? void 0 : _a.has(measurement)),
          name: "quick-add--" + label,
          onChange: function onChange() {
            dispatch({
              type: DIMENSION_CHANGE,
              payload: {
                dimension: dimension,
                measurement: measurement
              }
            });
          },
          selected: selectedDimensions[dimension.label] === measurement,
          shouldDisplayInStock: true,
          value: measurement
        });
      })));
    }));
  });
}

var templateObject_1$c, templateObject_2$6;
/** @jsx jsx */

var VariantRadio = function VariantRadio(props) {
  var id = props.id,
      variant = props.variant,
      selected = props.selected,
      onChange = props.onChange,
      className = props.className;
  var name = variant.name;
  var variantClasses = classnames('pdp-variant', {
    selected: selected
  });
  return jsx("div", {
    className: className + " " + variantClasses
  }, jsx("input", {
    "aria-label": name,
    checked: selected,
    className: "pdp-variant__radio",
    id: id,
    name: "fit-radio",
    onChange: onChange,
    type: "radio",
    value: name
  }), jsx("label", {
    "aria-hidden": true,
    className: "pdp-variant__label",
    htmlFor: id
  }, name));
};

function variantRadioStyles(theme) {
  var linkOverride = function linkOverride() {
    return "\n    a {\n      width: 100%;\n\n      &:visited,\n      &:active {\n        color: inherit;\n      }\n    }\n  ";
  };

  var variantLabelPadding = forBrands(theme, {
    default: function _default() {
      return '0.5em 0';
    },
    gap: function gap() {
      return '0.7em 0 0.5em';
    },
    gapfs: function gapfs() {
      return '0.7em 0 0.5em';
    }
  });
  var borders = forBrands(theme, {
    default: function _default() {
      return "\n      &:nth-of-type(n + 2) {\n        border-left: 1px solid " + theme.color.g4 + ";\n      }\n    ";
    },
    on: function on() {
      return "\n      border-color: " + theme.color.b1 + ";\n      border-style: solid;\n      border-width: 1px 0;\n\n      &:first-of-type {\n        border-left-width: 1px;\n      }\n\n      &:nth-of-type(n + 2) {\n        border-left-width: 1px;\n      }\n\n      &:last-of-type {\n        border-right-width: 1px;\n      }\n    ";
    }
  });
  var selectedBackground = forBrands(theme, {
    gap: function gap() {
      return theme.color.g4;
    },
    gapfs: function gapfs() {
      return theme.color.g4;
    },
    brfs: function brfs() {
      return theme.color.g1;
    },
    on: function on() {
      return theme.color.g1;
    },
    at: function at() {
      return theme.color.g5;
    }
  });
  var selectedFont = forBrands(theme, {
    gap: function gap() {
      return theme.font.secondary;
    },
    gapfs: function gapfs() {
      return theme.font.secondary;
    },
    on: function on() {
      return theme.font.secondary;
    },
    at: function at() {
      return theme.font.secondary;
    }
  });
  var focus = forBrands(theme, {
    gap: function gap(theme) {
      return "color: " + theme.color.b1 + ";";
    },
    gapfs: function gapfs(theme) {
      return "color: " + theme.color.b1 + ";";
    },
    br: function br() {
      return "color: " + theme.color.wh + ";\n      background-color: " + theme.color.b1 + ";\n      position: relative;\n\n      &::before {\n        content: '';\n        width: 100%;\n        height: 100%;\n        top: -1px;\n        left: -1px;\n        position: absolute;\n        background: transparent;\n      }\n      " + linkOverride;
    },
    brfs: function brfs() {
      return "color: " + theme.color.wh + ";\n      background-color: " + theme.color.b1 + ";\n      position: relative;\n\n      &::before {\n        content: '';\n        width: 100%;\n        height: 100%;\n        top: -1px;\n        left: -1px;\n        position: absolute;\n        background: transparent;\n      }\n      " + linkOverride;
    },
    on: function on(theme) {
      return "\n      color: " + theme.color.wh + ";\n      border-color: " + theme.color.g1 + ";\n    ";
    }
  });
  return css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n    text-transform: uppercase;\n    text-align: center;\n    cursor: pointer;\n    ", "\n    padding: ", ";\n    ", "\n    ", "\n\n    &.selected {\n      ", "\n      background-color: ", ";\n      ", "\n    }\n\n    .pillbox--2-across & {\n      width: 50%;\n    }\n\n    .pillbox--3-across & {\n      width: 33.33333%;\n    }\n\n    .pillbox--4-across & {\n      width: 25%;\n    }\n\n    & a {\n      display: block;\n    }\n\n    & .pdp-variant__radio {\n      ", "\n    }\n  "], ["\n    text-transform: uppercase;\n    text-align: center;\n    cursor: pointer;\n    ", "\n    padding: ", ";\n    ", "\n    ", "\n\n    &.selected {\n      ", "\n      background-color: ", ";\n      ", "\n    }\n\n    .pillbox--2-across & {\n      width: 50%;\n    }\n\n    .pillbox--3-across & {\n      width: 33.33333%;\n    }\n\n    .pillbox--4-across & {\n      width: 25%;\n    }\n\n    & a {\n      display: block;\n    }\n\n    & .pdp-variant__radio {\n      ", "\n    }\n  "])), theme.font.primary, variantLabelPadding, borders, sdsHeadingE(theme), focus, selectedBackground, selectedFont, theme.utilities.focusableHide);
}

var templateObject_1$d;

var theme2019Styles$1 = function theme2019Styles$1(isNewBrFontEnabled) {
  return function (theme) {
    var defaultVariantStyles = {
      fontSize: isNewBrFontEnabled ? '1rem' : '0.875rem',
      letterSpacing: 'auto'
    };
    var defaultForOtherBrands = {
      fontSize: '1rem',
      letterSpacing: 'auto'
    };

    var brNotSelected = _assign(_assign(_assign({}, theme.font.primary), defaultVariantStyles), {
      letterSpacing: '1px'
    });

    var variantFontPrimaryStyles = forBrands(theme, {
      br: brNotSelected,
      brfs: brNotSelected,
      default: defaultForOtherBrands
    });

    var brNewFontUpdates = _assign(_assign({}, theme.font.primary), defaultVariantStyles);

    var defaultWithFontSecondary = _assign(_assign({}, theme.font.secondary), defaultForOtherBrands);

    var variantFontSecondaryStyles = forBrands(theme, {
      br: isNewBrFontEnabled ? brNewFontUpdates : defaultWithFontSecondary,
      brfs: isNewBrFontEnabled ? brNewFontUpdates : defaultWithFontSecondary,
      default: defaultWithFontSecondary
    });
    return css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    display: inline-block;\n    color: ", ";\n    ", "\n    margin-right: 1.75rem;\n    padding: 0.25rem 0 0;\n    width: auto;\n    border: none;\n    border-bottom: 3px solid;\n    border-color: ", ";\n\n    &:nth-of-type(n + 2) {\n      border-left: none;\n    }\n\n    &.selected {\n      ", "\n      border-color: ", ";\n      color: ", ";\n      background-color: transparent;\n    }\n\n    & .pdp-variant__radio + .pdp-variant__label {\n      position: relative;\n      display: inline-block;\n    }\n\n    & .pdp-variant__radio.focus-visible + .pdp-variant__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "], ["\n    display: inline-block;\n    color: ", ";\n    ", "\n    margin-right: 1.75rem;\n    padding: 0.25rem 0 0;\n    width: auto;\n    border: none;\n    border-bottom: 3px solid;\n    border-color: ", ";\n\n    &:nth-of-type(n + 2) {\n      border-left: none;\n    }\n\n    &.selected {\n      ", "\n      border-color: ", ";\n      color: ", ";\n      background-color: transparent;\n    }\n\n    & .pdp-variant__radio + .pdp-variant__label {\n      position: relative;\n      display: inline-block;\n    }\n\n    & .pdp-variant__radio.focus-visible + .pdp-variant__label {\n      outline: 0;\n      box-shadow: 0 0 0 3px ", ";\n    }\n  "])), theme.color.b1, variantFontPrimaryStyles, theme.color.wh, variantFontSecondaryStyles, theme.color.b1, theme.color.b1, theme.crossBrand.color.b2);
  };
};

var templateObject_1$e;

function quickAddStyles$1() {
  return css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    font-size: 0.7rem;\n  "], ["\n    font-size: 0.7rem;\n  "])));
}

var templateObject_1$f;

function shouldRenderVariants(variants) {
  var variantCount = variants.length;
  return variantCount > 1 && variantCount < 5 || variantCount === 1 && variants[0].id !== 1 // If the only variant is Regular, don't render it
  ;
}

function variantGroupStyles() {
  return css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    margin-bottom: 1rem;\n    margin-left: 0.5rem;\n\n    & .radio-container__label {\n      ", "\n    }\n  "], ["\n    margin-bottom: 1rem;\n    margin-left: 0.5rem;\n\n    & .radio-container__label {\n      ", "\n    }\n  "])), visuallyHide$1());
}

var templateObject_1$g;

var VariantGroup = function VariantGroup(props) {
  var pid = props.pid,
      variants = props.variants,
      _a = props.selectedVariant,
      selectedVariant = _a === void 0 ? {
    id: null
  } : _a,
      dispatch = props.dispatch,
      htmlProps = __rest(props, ["pid", "variants", "selectedVariant", "dispatch"]);

  var localize = useLocalize().localize;
  var variantGroupLabel = localize('quickAdd.variantGroupLabel');
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var abbrBrand = useAppState$1().brandName;
  var newFontFeatureFlag = ['br', 'brfs'].includes(abbrBrand) ? 'enable-new-br-fonts' : '';
  var isNewBrFontEnabled = enabledFeatures[newFontFeatureFlag];

  if (!shouldRenderVariants(variants)) {
    return null;
  }

  return jsx("div", {
    "aria-labelledby": "swatch-label--Variant",
    css: variantGroupStyles,
    role: "radiogroup"
  }, jsx("span", {
    className: "radio-container__label",
    id: "swatch-label--Variant"
  }, variantGroupLabel), variants.map(function (variant) {
    var id = pid + "-variant-radio-" + variant.id;
    return jsx(VariantRadio, _assign({
      key: variant.name,
      css: function css$1(theme) {
        return css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "])), variantRadioStyles(theme), theme2019Styles$1(isNewBrFontEnabled)(theme), quickAddStyles$1());
      },
      id: id,
      onChange: function onChange() {
        dispatch({
          type: VARIANT_CHANGE,
          payload: {
            variant: variant
          }
        });
      },
      selected: variant.id === selectedVariant.id,
      variant: variant
    }, htmlProps));
  }));
};

var VariantGroup$1 = /*#__PURE__*/memo(VariantGroup);
var templateObject_1$h;
var SizeSelectorMemo = /*#__PURE__*/memo(function SizeSelector(_a) {
  var dispatch = _a.dispatch,
      variants = _a.variants,
      selectedVariant = _a.selectedVariant,
      selectedDimensions = _a.selectedDimensions,
      outOfStockDimensions = _a.outOfStockDimensions,
      pid = _a.pid;
  var brandName = useAppState$1().brandName;
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var gothamFontEnabled = enabledFeatures["enable-" + brandName + "-gotham-font"];
  return jsx(QuickAddContext.Consumer, null, function (_a) {
    var styles = _a.styles;
    var sizeSelectorStyles = styles.sizeSelectorStyles;
    return jsx("div", {
      className: "quick-add-size-selector",
      css: function css$1(theme) {
        return css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n                ", "\n              "], ["\n                ", "\n              "])), sizeSelectorStyles(theme, gothamFontEnabled));
      }
    }, jsx(VariantGroup$1, {
      dispatch: dispatch,
      pid: pid,
      selectedVariant: selectedVariant,
      variants: variants
    }), jsx(DimensionGroups, {
      dimensions: selectedVariant.dimensions,
      dispatch: dispatch,
      outOfStockDimensions: outOfStockDimensions,
      pid: pid,
      selectedDimensions: selectedDimensions
    }));
  });
});
var templateObject_1$i;
/** @jsx jsx */

function QuickAddContainer(_a) {
  var addToBagUrls = _a.addToBagUrls,
      clientId = _a.clientId,
      data = _a.data,
      onAddToBag = _a.onAddToBag,
      enableLegacyAddToBag = _a.enableLegacyAddToBag,
      pid = _a.pid,
      reportQuickAddStart = _a.reportQuickAddStart,
      errorLogger = _a.errorLogger;
  var localize = useLocalize().localize;
  var colorLabel = localize('pdp.colorLabel');
  var nonMergedVariants = getRegularVariants(data.variants);
  var inStockVariants = nonMergedVariants.filter(isVariantInStock);

  var _b = useReducer(quickAddReducer, inStockVariants, initQuickAddState),
      state = _b[0],
      dispatch = _b[1];

  var name = data.name,
      price = data.price,
      colorName = data.colorName;
  var inProgress = state.inProgress,
      outOfStockDimensions = state.outOfStockDimensions,
      response = state.response,
      selectedDimensions = state.selectedDimensions,
      selectedSku = state.selectedSku,
      selectedVariant = state.selectedVariant,
      unselectedDimensions = state.unselectedDimensions;
  var productInformation = name + " and " + colorLabel + ": " + colorName;
  useEffect(function () {
    reportQuickAddStart(selectedVariant); // DO NOT ADD DEPENDENCIES TO THE DEPS ARRAY
    // This is supposed to run only when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(QuickAddProvider, {
    quickAddVersion: DEFAULT_VERSION
  }, jsx("div", {
    "data-testid": DEFAULT_VERSION
  }, jsx("h2", {
    css: productTitleStyles,
    id: "quick-add-product-title"
  }, productInformation), jsx(SizeSelectorMemo, {
    dispatch: dispatch,
    outOfStockDimensions: outOfStockDimensions,
    pid: pid,
    selectedDimensions: selectedDimensions,
    selectedVariant: selectedVariant,
    variants: inStockVariants
  }), jsx(AddToBag, {
    addToBagUrls: addToBagUrls,
    clientId: clientId,
    dispatch: dispatch,
    enableLegacyAddToBag: enableLegacyAddToBag,
    errorLogger: errorLogger,
    inProgress: inProgress,
    name: name,
    onAddToBag: onAddToBag,
    pid: pid,
    price: price,
    response: response,
    selectedDimensions: selectedDimensions,
    selectedSku: selectedSku,
    unselectedDimensions: unselectedDimensions
  })));
}
/** @jsx jsx */


function QuickAddContainerWithImage(_a) {
  var addToBagUrls = _a.addToBagUrls,
      clientId = _a.clientId,
      data = _a.data,
      onAddToBag = _a.onAddToBag,
      enableLegacyAddToBag = _a.enableLegacyAddToBag,
      pid = _a.pid,
      reportQuickAddStart = _a.reportQuickAddStart,
      errorLogger = _a.errorLogger;
  var nonMergedVariants = getRegularVariants(data.variants);
  var localize = useLocalize().localize;
  var colorLabel = localize('quickAdd.colorLabel');
  var inStockVariants = nonMergedVariants.filter(isVariantInStock);

  var _b = useReducer(quickAddReducer, inStockVariants, initQuickAddState),
      state = _b[0],
      dispatch = _b[1];

  var name = data.name,
      price = data.price,
      colorName = data.colorName;
  var inProgress = state.inProgress,
      outOfStockDimensions = state.outOfStockDimensions,
      response = state.response,
      selectedDimensions = state.selectedDimensions,
      selectedSku = state.selectedSku,
      selectedVariant = state.selectedVariant,
      unselectedDimensions = state.unselectedDimensions;
  var productInformation = name + " and " + colorLabel + ": " + colorName;
  useEffect(function () {
    reportQuickAddStart(selectedVariant); // DO NOT ADD DEPENDENCIES TO THE DEPS ARRAY
    // This is supposed to run only when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(QuickAddProvider, {
    quickAddVersion: WITH_PRODUCT_IMAGE_VERSION
  }, jsx(QuickAddContext.Consumer, null, function (_a) {
    var styles = _a.styles;
    var imageContainerStyles = styles.imageContainerStyles,
        imageStyles = styles.imageStyles,
        dimensionsContainerStyles = styles.dimensionsContainerStyles,
        productTitleStyles = styles.productTitleStyles;
    return jsx(Fragment, null, jsx("h2", {
      css: productTitleStyles,
      id: "quick-add-product-title"
    }, productInformation), jsx("div", {
      css: imageContainerStyles,
      "data-testid": WITH_PRODUCT_IMAGE_VERSION
    }, jsx("img", {
      alt: name,
      css: imageStyles,
      src: data.mainImage.medium
    })), jsx("div", {
      css: dimensionsContainerStyles
    }, jsx(SizeSelectorMemo, {
      dispatch: dispatch,
      outOfStockDimensions: outOfStockDimensions,
      pid: pid,
      selectedDimensions: selectedDimensions,
      selectedVariant: selectedVariant,
      variants: inStockVariants
    }), jsx(AddToBag, {
      addToBagUrls: addToBagUrls,
      clientId: clientId,
      dispatch: dispatch,
      enableLegacyAddToBag: enableLegacyAddToBag,
      errorLogger: errorLogger,
      inProgress: inProgress,
      name: name,
      onAddToBag: onAddToBag,
      pid: pid,
      price: price,
      response: response,
      selectedDimensions: selectedDimensions,
      selectedSku: selectedSku,
      unselectedDimensions: unselectedDimensions
    })));
  }));
}

function checkError(response) {
  if (response.ok) {
    return response;
  }

  var status = response.status;
  throw Error(status.toString());
}

function useFetch(url, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = useState(null),
      status = _a[0],
      setStatus = _a[1];

  var _b = useState(null),
      data = _b[0],
      setData = _b[1];

  var _c = useState(null),
      error = _c[0],
      setError = _c[1];

  function fetchOnce() {
    setStatus('pending');
    setData(null);
    setError(null);
    return fetch(url, options).then(checkError).then(function (res) {
      return res.json();
    }).then(function (res) {
      setData(res);
      setStatus('complete');
      setError(null);
    }).catch(function (err) {
      setData(null);
      setStatus('error');
      setError(err);
    });
  }

  useEffect(function () {
    fetchOnce();
  }, [url]);
  return {
    fetchOnce: fetchOnce,
    status: status,
    data: data,
    error: error
  };
}

var apiBaseUrl = 'https://readservices-b2c.powerreviews.com';

var useReviewRatings = function useReviewRatings(_a) {
  var reviews = _a.reviews,
      pid = _a.pid,
      _b = _a.locale,
      locale = _b === void 0 ? 'en_US' : _b,
      powerReviewsConfig = _a.powerReviewsConfig,
      powerReviewsAllLocaleEnabled = _a.powerReviewsAllLocaleEnabled;
  if (reviews) return reviews;
  var merchantId = powerReviewsConfig.merchantId,
      apiKey = powerReviewsConfig.apiKey;
  var sixDigitPid = pid === null || pid === void 0 ? void 0 : pid.substring(0, 6);
  var prLocale = powerReviewsAllLocaleEnabled ? 'all' : locale;
  var url = apiBaseUrl + "/m/" + merchantId + "/l/" + prLocale + "/product/" + sixDigitPid + "/snippet?_noconfig=true";
  var fetchOptions = {
    headers: {
      Authorization: apiKey
    },
    timeout: 1000
  }; // eslint-disable-next-line react-hooks/rules-of-hooks

  var data = useFetch(url, fetchOptions).data;
  var rollup = ((data === null || data === void 0 ? void 0 : data.results[0]) || {}).rollup;
  return {
    starRating: rollup === null || rollup === void 0 ? void 0 : rollup.average_rating,
    reviewCount: rollup === null || rollup === void 0 ? void 0 : rollup.review_count
  };
};

var ProductInfoHeader = function ProductInfoHeader(_a) {
  var productURL = _a.productURL,
      data = _a.data,
      reviews = _a.reviews;
  var brandName = useAppState$1().brandName;
  var localize = useLocalize().localize;
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var colorName = data.colorName,
      mainImage = data.mainImage,
      name = data.name;
  var _b = reviews.reviewCount,
      reviewCount = _b === void 0 ? 0 : _b,
      _c = reviews.starRating,
      starRating = _c === void 0 ? 0 : _c;
  var colorLabel = localize('quickAdd.colorLabel');
  var tertiaryFontEnabled = enabledFeatures[brandName + "-tertiary-font"];
  var fontClass = tertiaryFontEnabled ? 'show-tertiary-font' : '';
  var pluralLabel = localize('fui.ReviewRatings.pluralLabel', {
    reviewCount: reviewCount
  });
  var singularLabel = localize('fui.ReviewRatings.singularLabel', {
    reviewCount: reviewCount
  });
  var ratingsLabel = reviewCount === 1 ? singularLabel : pluralLabel;
  var brFontFeatureFlag = ['br', 'brfs'].includes(brandName) ? 'enable-new-br-fonts' : '';
  var brFontEnabled = enabledFeatures[brFontFeatureFlag];
  return jsx(QuickAddContext.Consumer, null, function (_a) {
    var styles = _a.styles;
    var colorNameStyles = styles.colorNameStyles,
        headerStyles = styles.headerStyles,
        imageStyles = styles.imageStyles,
        productInfoStyles = styles.productInfoStyles,
        productTitleStyles = styles.productTitleStyles,
        reviewWrapperStyles = styles.reviewWrapperStyles,
        reviewCountStyles = styles.reviewCountStyles;
    return jsx("div", {
      className: "quick-add__header",
      css: headerStyles
    }, jsx("div", {
      className: "quick-add__product-image"
    }, jsx("a", {
      css: imageStyles,
      href: productURL
    }, jsx("img", {
      alt: name,
      "data-testid": "imageContainer",
      src: mainImage.medium
    }))), jsx("div", {
      className: "quick-add__product-info",
      css: productInfoStyles
    }, jsx("a", {
      className: fontClass,
      css: function css$1(theme) {
        return css(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n                    ", "\n                  "], ["\n                    ", "\n                  "])), productTitleStyles(theme, brFontEnabled));
      },
      href: productURL
    }, jsx("h2", {
      dangerouslySetInnerHTML: {
        __html: name
      },
      id: "quick-add-product-title"
    })), jsx("div", {
      className: "quick-add_review-ratings",
      css: reviewWrapperStyles
    }, jsx(ReviewRatings, {
      starRating: starRating,
      tabIndex: -1
    }), jsx("span", {
      "aria-label": ratingsLabel,
      css: function css$1(theme) {
        return css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n                      ", "\n                    "], ["\n                      ", "\n                    "])), reviewCountStyles(theme, brFontEnabled));
      },
      "data-testid": "review-count"
    }, reviewCount > 0 ? "(" + reviewCount + ")" : '')), jsx("div", {
      className: "quick-add__color-name",
      css: function css$1(theme) {
        return css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n                    ", "\n                  "], ["\n                    ", "\n                  "])), colorNameStyles(theme, brFontEnabled));
      }
    }, jsx("span", {
      className: "color-label"
    }, colorLabel, ": "), jsx("span", {
      className: fontClass,
      dangerouslySetInnerHTML: {
        __html: colorName
      }
    }))));
  });
};

var templateObject_1$j, templateObject_2$7, templateObject_3$4;

var buildProductPageURL = function buildProductPageURL(selectedSku, pid) {
  var productID = selectedSku ? selectedSku.skuId : pid;
  return "/browse/product.do?pid=" + productID + "#pdp-page-content";
};

function QuickAddContainerWithProductInfo(_a) {
  var addToBagUrls = _a.addToBagUrls,
      clientId = _a.clientId,
      data = _a.data,
      onAddToBag = _a.onAddToBag,
      enableLegacyAddToBag = _a.enableLegacyAddToBag,
      pid = _a.pid,
      locale = _a.locale,
      brandName = _a.brandName,
      powerReviewsConfig = _a.powerReviewsConfig,
      reviews = _a.reviews,
      reportQuickAddStart = _a.reportQuickAddStart,
      errorLogger = _a.errorLogger;
  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var nonMergedVariants = getRegularVariants(data.variants);
  var inStockVariants = nonMergedVariants.filter(isVariantInStock);

  var _b = useReducer(quickAddReducer, inStockVariants, initQuickAddState),
      state = _b[0],
      dispatch = _b[1];

  var marketingFlag = data.marketingFlag,
      name = data.name,
      price = data.price;
  var inProgress = state.inProgress,
      outOfStockDimensions = state.outOfStockDimensions,
      response = state.response,
      selectedDimensions = state.selectedDimensions,
      selectedSku = state.selectedSku,
      selectedVariant = state.selectedVariant,
      unselectedDimensions = state.unselectedDimensions;
  var productURL = buildProductPageURL(selectedSku, pid);
  var powerReviewsAllLocaleEnabled = enabledFeatures['pdp-power-reviews-all-locale'];
  var reviewsResponse = useReviewRatings({
    pid: pid,
    locale: locale,
    powerReviewsConfig: powerReviewsConfig,
    reviews: reviews,
    powerReviewsAllLocaleEnabled: powerReviewsAllLocaleEnabled
  });
  var brFontFeatureFlag = ['br', 'brfs'].includes(brandName) ? 'enable-new-br-fonts' : '';
  var brFontEnabled = enabledFeatures[brFontFeatureFlag];
  useEffect(function () {
    reportQuickAddStart(selectedVariant); // DO NOT ADD DEPENDENCIES TO THE DEPS ARRAY
    // This is supposed to run only when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(QuickAddProvider, {
    quickAddVersion: WITH_PRODUCT_INFO_VERSION
  }, jsx(QuickAddContext.Consumer, null, function (_a) {
    var styles = _a.styles;
    var containerStyles = styles.containerStyles,
        dimensionsContainerStyles = styles.dimensionsContainerStyles,
        marketingFlagStyles = styles.marketingFlagStyles;
    return jsx("div", {
      css: containerStyles,
      "data-testid": WITH_PRODUCT_INFO_VERSION
    }, jsx(ProductInfoHeader, {
      data: data,
      productURL: productURL,
      reviews: reviewsResponse
    }), jsx("div", {
      css: dimensionsContainerStyles
    }, jsx(SizeSelectorMemo, {
      dispatch: dispatch,
      outOfStockDimensions: outOfStockDimensions,
      pid: pid,
      selectedDimensions: selectedDimensions,
      selectedVariant: selectedVariant,
      variants: inStockVariants
    }), jsx(AddToBag, {
      addToBagUrls: addToBagUrls,
      clientId: clientId,
      dispatch: dispatch,
      enableLegacyAddToBag: enableLegacyAddToBag,
      errorLogger: errorLogger,
      inProgress: inProgress,
      name: name,
      onAddToBag: onAddToBag,
      pid: pid,
      price: price,
      response: response,
      selectedDimensions: selectedDimensions,
      selectedSku: selectedSku,
      unselectedDimensions: unselectedDimensions
    })), marketingFlag && jsx("span", {
      className: "quick-add__marketing-flag",
      css: function css$1(theme) {
        return css(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n                      ", "\n                    "], ["\n                      ", "\n                    "])), marketingFlagStyles(theme, brFontEnabled));
      }
    }, marketingFlag));
  }));
}

var templateObject_1$k;
/**
 * Build url according to the provided path and query
 * @param {String} base - can be an host or static url with protocal e.g. https://api.test.com or http://api.gap.com/ux/etc ..
 * @param {Object} queryPrams - an object contains the query key - value pair.
 * @param {String} pathPattern - string pattern for url path part, use {index} as the placeholder if you need to replace it with pathParams
 * @param {Array} pathParams - A string array to use to replace the corresponding placeholder in pathPattern.
 * @returns {String} - the output URL
 */

var buildURL = function buildURL(_a) {
  var base = _a.base,
      _b = _a.queryParams,
      queryParams = _b === void 0 ? {} : _b,
      pathPattern = _a.pathPattern,
      _c = _a.pathParams,
      pathParams = _c === void 0 ? [] : _c;
  var endpoint = new URL(base);
  Object.entries(queryParams).forEach(function (_a) {
    var key = _a[0],
        val = _a[1];
    endpoint.searchParams.set(key, val);
  });
  var path = pathPattern;

  if (pathParams.length > 0) {
    pathParams.forEach(function (item, index) {
      path = path.split("{" + index + "}").join(item);
    });
  }

  if (!path.startsWith('/')) {
    path = "/" + path;
  }

  if (endpoint.pathname === '/') {
    endpoint.pathname = path;
  } else {
    endpoint.pathname = "" + endpoint.pathname + path;
  }

  return endpoint.href;
};

var useProductStyle = function useProductStyle(productStyleParams) {
  var pid = productStyleParams.pid,
      brand = productStyleParams.brand,
      market = productStyleParams.market,
      country = productStyleParams.country,
      contentType = productStyleParams.contentType,
      locale = productStyleParams.locale,
      apiConfig = productStyleParams.apiConfig,
      pssUrl = productStyleParams.pssUrl;
  var apikey = apiConfig.pssApiKey;
  var endpoint = buildURL({
    base: pssUrl,
    queryParams: {
      brand: brand === null || brand === void 0 ? void 0 : brand.toUpperCase(),
      market: market === null || market === void 0 ? void 0 : market.toUpperCase(),
      country: country === null || country === void 0 ? void 0 : country.toUpperCase(),
      locale: locale,
      colorLevel: true,
      requestType: contentType
    },
    pathPattern: '/product-styles/{0}',
    pathParams: [pid]
  });
  return useFetch(endpoint, {
    headers: {
      apikey: apikey
    }
  });
};

var quickAddBaseStyles = css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 2.5rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-top: 2.5rem;\n"])));

var quickAddStylesWithImage = css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  display: flex;\n  padding-top: 4.5rem;\n\n  @media (max-width: 693px) {\n    display: block;\n    padding-top: 2.5rem;\n  }\n"], ["\n  display: flex;\n  padding-top: 4.5rem;\n\n  @media (max-width: 693px) {\n    display: block;\n    padding-top: 2.5rem;\n  }\n"])));

var templateObject_1$l, templateObject_2$8;

var shortenFrenchLabels = function shortenFrenchLabels(data) {
  return _assign(_assign({}, data), {
    variants: data === null || data === void 0 ? void 0 : data.variants.map(function (v) {
      if (v.name.toLowerCase() !== 'grandes tailles') return v;
      return _assign(_assign({}, v), {
        name: 'Grandes'
      });
    })
  });
};

var brandCodeUrls = {
  us: {
    gap: {
      secureUrl: "https://secure-www.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://secure-bananarepublic.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://secure-oldnavy.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://secure-athleta.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    gapfs: {
      secureUrl: "https://secure-www.gapfactory.com",
      oidcUrl: "https://api.gapfactory.com",
      productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
    },
    brfs: {
      secureUrl: "https://secure-bananarepublicfactory.gapfactory.com",
      oidcUrl: "https://api.gapfactory.com",
      productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://secure-www.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://secure-bananarepublic.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://secure-oldnavy.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://secure-athleta.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    }
  }
};
var powerReviewsConfig = {
  en_US: {
    gap: {
      groupId: 524780421,
      merchantId: 1443032450,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    on: {
      groupId: 524780421,
      merchantId: 650520397,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    br: {
      groupId: 524780421,
      merchantId: 911560314,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    at: {
      groupId: 524780421,
      merchantId: 1367436744,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    gapfs: {
      groupId: 160838694,
      merchantId: 1109823159,
      apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
    },
    brfs: {
      groupId: 160838694,
      merchantId: 1516339149,
      apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
    }
  },
  en_CA: {
    gap: {
      groupId: 1373651604,
      merchantId: 149259715,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    on: {
      groupId: 1373651604,
      merchantId: 30636116,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    br: {
      groupId: 1373651604,
      merchantId: 674040222,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    at: {
      groupId: 1373651604,
      merchantId: 654468223,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    }
  },
  fr_CA: {
    gap: {
      groupId: 1373651604,
      merchantId: 1522080150,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    on: {
      groupId: 1373651604,
      merchantId: 1954404204,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    br: {
      groupId: 1373651604,
      merchantId: 1362840637,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    at: {
      groupId: 1373651604,
      merchantId: 1774256798,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    }
  }
};
var productStyleService = "https://api.gap.com/ux/web/product-style-web-experience";
var defaultConfigs = {
  brandCodeUrls: brandCodeUrls,
  powerReviewsConfig: powerReviewsConfig,
  productStyleService: productStyleService
};
var brandCodeUrls$1 = {
  us: {
    gap: {
      secureUrl: "https://secure-www.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://secure-bananarepublic.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://secure-oldnavy.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://secure-athleta.gap.com",
      oidcUrl: "https://api.gap.com",
      productStyleService: "https://api.gap.com/ux/web/product-style-web-experience"
    },
    gapfs: {
      secureUrl: "https://secure-www.gapfactory.com",
      oidcUrl: "https://api.gapfactory.com",
      productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
    },
    brfs: {
      secureUrl: "https://secure-bananarepublicfactory.gapfactory.com",
      oidcUrl: "https://api.gapfactory.com",
      productStyleService: "https://api.gapfactory.com/ux/web/product-style-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://secure-www.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://secure-bananarepublic.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://secure-oldnavy.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://secure-athleta.gapcanada.ca",
      oidcUrl: "https://api.gapcanada.ca",
      productStyleService: "https://api.gapcanada.ca/ux/web/product-style-web-experience"
    }
  }
};
var powerReviewsConfig$1 = {
  en_US: {
    gap: {
      groupId: 524780421,
      merchantId: 1443032450,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    on: {
      groupId: 524780421,
      merchantId: 650520397,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    br: {
      groupId: 524780421,
      merchantId: 911560314,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    at: {
      groupId: 524780421,
      merchantId: 1367436744,
      apiKey: "96e4b93c-348e-4f21-847b-028497ff9f1c"
    },
    gapfs: {
      groupId: 160838694,
      merchantId: 1109823159,
      apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
    },
    brfs: {
      groupId: 160838694,
      merchantId: 1516339149,
      apiKey: "953904b2-06b6-4861-8eae-fd73f81ff303"
    }
  },
  en_CA: {
    gap: {
      groupId: 1373651604,
      merchantId: 149259715,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    on: {
      groupId: 1373651604,
      merchantId: 30636116,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    br: {
      groupId: 1373651604,
      merchantId: 674040222,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    at: {
      groupId: 1373651604,
      merchantId: 654468223,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    }
  },
  fr_CA: {
    gap: {
      groupId: 1373651604,
      merchantId: 1522080150,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    on: {
      groupId: 1373651604,
      merchantId: 1954404204,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    br: {
      groupId: 1373651604,
      merchantId: 1362840637,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    },
    at: {
      groupId: 1373651604,
      merchantId: 1774256798,
      apiKey: "5851b3ec-993b-490b-a29c-e2ec0849fe4f"
    }
  }
};
var productStyleService$1 = "https://api.gap.com/ux/web/product-style-web-experience";
var prod = {
  brandCodeUrls: brandCodeUrls$1,
  powerReviewsConfig: powerReviewsConfig$1,
  productStyleService: productStyleService$1
};
var brandCodeUrls$2 = {
  us: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}test.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}test.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}test.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}test.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    gapfs: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}test.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.factory-{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    brfs: {
      secureUrl: "https://{{subdomain}}brfol.{{contentType}}test.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.factory-{{domain}}.com",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}test.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}test.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}test.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}test.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.live.test.{{domain}}.ca",
      productStyleService: "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    }
  }
};
var powerReviewsConfig$2 = {
  en_US: {
    gap: {
      groupId: 78519,
      merchantId: 651534,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    on: {
      groupId: 78519,
      merchantId: 41628,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    br: {
      groupId: 78519,
      merchantId: 377605,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    at: {
      groupId: 78519,
      merchantId: 123756,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    gapfs: {
      groupId: 80934,
      merchantId: 485459,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    },
    brfs: {
      groupId: 80934,
      merchantId: 69585,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    }
  },
  en_CA: {
    gap: {
      groupId: 80931,
      merchantId: 216454,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 372736,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 956586,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 274124135,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  },
  fr_CA: {
    gap: {
      groupId: 80931,
      merchantId: 70571,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 202293,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 38986,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 1055652790,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  }
};
var productStyleService$2 = "https://test.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var test = {
  brandCodeUrls: brandCodeUrls$2,
  powerReviewsConfig: powerReviewsConfig$2,
  productStyleService: productStyleService$2
};
var brandCodeUrls$3 = {
  us: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    gapfs: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    brfs: {
      secureUrl: "https://{{subdomain}}brfol.{{contentType}}stage.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience"
    }
  }
};
var powerReviewsConfig$3 = {
  en_US: {
    gap: {
      groupId: 78519,
      merchantId: 651534,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    on: {
      groupId: 78519,
      merchantId: 41628,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    br: {
      groupId: 78519,
      merchantId: 377605,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    at: {
      groupId: 78519,
      merchantId: 123756,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    gapfs: {
      groupId: 80934,
      merchantId: 485459,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    },
    brfs: {
      groupId: 80934,
      merchantId: 69585,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    }
  },
  en_CA: {
    gap: {
      groupId: 80931,
      merchantId: 216454,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 372736,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 956586,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 274124135,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  },
  fr_CA: {
    gap: {
      groupId: 80931,
      merchantId: 70571,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 202293,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 38986,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 1055652790,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  }
};
var productStyleService$3 = "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var local = {
  brandCodeUrls: brandCodeUrls$3,
  powerReviewsConfig: powerReviewsConfig$3,
  productStyleService: productStyleService$3
};
var brandCodeUrls$4 = {
  us: {
    gap: {
      secureUrl: "https://secure.www.{{contentType}}prod.gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    br: {
      secureUrl: "https://secure.brol.{{contentType}}prod.gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    on: {
      secureUrl: "https://secure.onol.{{contentType}}prod.gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    at: {
      secureUrl: "https://secure.atol.{{contentType}}prod.gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    gapfs: {
      secureUrl: "https://secure.www.{{contentType}}prod.factory-gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.factory-gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    brfs: {
      secureUrl: "https://secure.brfol.{{contentType}}prod.factory-gaptecholapps.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.factory-gaptecholapps.com",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://secure.www.{{contentType}}prod.gaptecholapps.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    br: {
      secureUrl: "https://secure.brol.{{contentType}}prod.gaptecholapps.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    on: {
      secureUrl: "https://secure.onol.{{contentType}}prod.gaptecholapps.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    },
    at: {
      secureUrl: "https://secure.atol.{{contentType}}prod.gaptecholapps.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.preview.{{contentType}}prod.gaptecholapps.ca",
      productStyleService: "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience"
    }
  }
};
var powerReviewsConfig$4 = {
  en_US: {
    gap: {
      groupId: 78519,
      merchantId: 651534,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    on: {
      groupId: 78519,
      merchantId: 41628,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    br: {
      groupId: 78519,
      merchantId: 377605,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    at: {
      groupId: 78519,
      merchantId: 123756,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    gapfs: {
      groupId: 80934,
      merchantId: 485459,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    },
    brfs: {
      groupId: 80934,
      merchantId: 69585,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    }
  },
  en_CA: {
    gap: {
      groupId: 80931,
      merchantId: 216454,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 372736,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 956586,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 274124135,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  },
  fr_CA: {
    gap: {
      groupId: 80931,
      merchantId: 70571,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 202293,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 38986,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 1055652790,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  }
};
var productStyleService$4 = "https://api.azeus.gaptech.com/ux/web/product-style-preview-web-experience";
var preview = {
  brandCodeUrls: brandCodeUrls$4,
  powerReviewsConfig: powerReviewsConfig$4,
  productStyleService: productStyleService$4
};
var brandCodeUrls$5 = {
  us: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.com",
      productStyleService: "https://stage.api.azeus.gap.com/ux/web/product-style-web-experience"
    },
    gapfs: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
      productStyleService: "https://stage.api.gapfactory.com/ux/web/product-style-web-experience"
    },
    brfs: {
      secureUrl: "https://{{subdomain}}brfol.{{contentType}}stage.factory-{{domain}}.com",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.factory-{{domain}}.com",
      productStyleService: "https://stage.api.gapfactory.com/ux/web/product-style-web-experience"
    }
  },
  ca: {
    gap: {
      secureUrl: "https://{{subdomain}}www.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    br: {
      secureUrl: "https://{{subdomain}}brol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    on: {
      secureUrl: "https://{{subdomain}}onol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
    },
    at: {
      secureUrl: "https://{{subdomain}}atol.{{contentType}}stage.{{domain}}.ca",
      oidcUrl: "https://secure-internal-azeus-ecom-api.{{oidcContentType}}.stage.{{domain}}.ca",
      productStyleService: "https://stage.api.gapcanada.ca/ux/web/product-style-web-experience"
    }
  }
};
var powerReviewsConfig$5 = {
  en_US: {
    gap: {
      groupId: 78519,
      merchantId: 651534,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    on: {
      groupId: 78519,
      merchantId: 41628,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    br: {
      groupId: 78519,
      merchantId: 377605,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    at: {
      groupId: 78519,
      merchantId: 123756,
      apiKey: "caa839d4-7812-4776-bcd9-caed7f476ede"
    },
    gapfs: {
      groupId: 80934,
      merchantId: 485459,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    },
    brfs: {
      groupId: 80934,
      merchantId: 69585,
      apiKey: "491f2f5e-acd0-41e0-bbaf-3748f345f489"
    }
  },
  en_CA: {
    gap: {
      groupId: 80931,
      merchantId: 216454,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 372736,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 956586,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 274124135,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  },
  fr_CA: {
    gap: {
      groupId: 80931,
      merchantId: 70571,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    on: {
      groupId: 80931,
      merchantId: 202293,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    br: {
      groupId: 80931,
      merchantId: 38986,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    },
    at: {
      groupId: 80931,
      merchantId: 1055652790,
      apiKey: "61789c08-4f93-48e9-9a41-4e748745d551"
    }
  }
};
var productStyleService$5 = "https://stage.api.azeus.gaptech.com/ux/web/product-style-web-experience";
var stage = {
  brandCodeUrls: brandCodeUrls$5,
  powerReviewsConfig: powerReviewsConfig$5,
  productStyleService: productStyleService$5
};
var environmentConfigs = {
  default: defaultConfigs,
  local: local,
  preview: preview,
  prod: prod,
  production: prod,
  stage: stage,
  test: test
};

var getFormattedBrandUrls = function getFormattedBrandUrls(_a) {
  var environment = _a.environment,
      config = _a.config,
      contentType = _a.contentType;
  var preview = contentType === 'wip' || contentType === 'app';
  var dynamicUrl = /{{contentType}}|{{subdomain}}|{{domain}}|{{oidcContentType}}/g;
  var replaceConfig = {
    '{{contentType}}': preview ? contentType + "." : '',
    '{{subdomain}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview ? 'secure.' : 'secure-',
    '{{domain}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview ? 'gaptecholapps' : 'gaptechol',
    '{{oidcContentType}}': (environment === 'stage' || environment === 'local' || environment === 'test') && preview ? "preview." + contentType : 'live'
  };

  function replacer(matched) {
    return replaceConfig === null || replaceConfig === void 0 ? void 0 : replaceConfig[matched];
  }

  return Object.entries(config).reduce(function (updatedConfig, _a) {
    var _b;

    var key = _a[0],
        value = _a[1];
    return _assign(_assign({}, updatedConfig), (_b = {}, _b[key] = value.replace(dynamicUrl, replacer), _b));
  }, {});
};

var getAddToBagUrl = function getAddToBagUrl(finalConfig, environment, brandAbbr, market, contentType) {
  var config = finalConfig.brandCodeUrls[market][brandAbbr];
  return getFormattedBrandUrls({
    environment: environment,
    config: config,
    contentType: contentType
  });
};

var getPssUrl = function getPssUrl(finalConfig, brandAbbr, market, apiHostForward) {
  var config = finalConfig.brandCodeUrls[market][brandAbbr];
  return apiHostForward ? config.productStyleService : finalConfig.productStyleService;
};
/** @jsx jsx */


var useAppState = extendableUseAppState; // if both flags come as true by mistake, we need to prioritize the productInfo version

var getQuickAddContainerStyles = function getQuickAddContainerStyles(showProductImage, showProductInfo) {
  if (showProductInfo) return quickAddBaseStyles;
  if (showProductImage) return quickAddStylesWithImage;
  return quickAddBaseStyles;
};

function QuickAdd(_a) {
  var _b;

  var apiConfig = _a.apiConfig,
      clientId = _a.clientId,
      pid = _a.pid,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      onAddToBag = _a.onAddToBag,
      _d = _a.reportQuickAddStart,
      reportQuickAddStart = _d === void 0 ? function () {} : _d,
      _e = _a.enableLegacyAddToBag,
      enableLegacyAddToBag = _e === void 0 ? false : _e,
      _f = _a.showProductImage,
      showProductImage = _f === void 0 ? false : _f,
      _g = _a.showProductInfo,
      showProductInfo = _g === void 0 ? false : _g,
      reviews = _a.reviews;
  var localize = useLocalize().localize;

  var _h = useAppState(),
      brandName = _h.brandName,
      contentType = _h.contentType,
      country = _h.country,
      env = _h.env,
      errorLogger = _h.errorLogger,
      locale = _h.locale,
      market = _h.market;

  var enabledFeatures = useContext(FeatureFlagsContext).enabledFeatures;
  var apiHostForward = enabledFeatures['pdp-apihost-rewrite'];
  var defaultConfig = environmentConfigs.default;
  var environmentConfig = environmentConfigs[env];
  var finalConfig = merge(defaultConfig, environmentConfig);
  var pssUrl = getPssUrl(finalConfig, brandName, market, apiHostForward);
  var powerReviewsConfig = finalConfig.powerReviewsConfig[locale][brandName];
  var addToBagUrls = getAddToBagUrl(finalConfig, env, brandName, market, contentType);

  var _j = useProductStyle({
    apiConfig: apiConfig,
    brand: brandName,
    country: country,
    contentType: contentType,
    market: market,
    locale: locale,
    pid: pid,
    pssUrl: pssUrl
  }),
      data = _j.data,
      status = _j.status;

  var errorComponentJSX = useMemo(function () {
    return jsx("div", {
      css: errorMessageStyles,
      role: "alert"
    }, localize('quickAdd.error.general'));
  }, [localize]);
  var OOSErrorComponentJSX = useMemo(function () {
    return jsx("div", {
      css: errorMessageStyles,
      role: "alert"
    }, localize('quickAdd.error.itemOutOfStock'));
  }, [localize]);
  var OOSProduct = data && ((_b = data.variants) === null || _b === void 0 ? void 0 : _b.length) && !data.variants.find(function (variant) {
    return variant.inStock;
  });
  var shouldDisplayProductInfoVersion = status === 'complete' && !OOSProduct && showProductInfo;
  var shouldDisplayProductImageVersion = status === 'complete' && !OOSProduct && showProductImage && !showProductInfo;
  var shouldDisplayDefaultVersion = status === 'complete' && !OOSProduct && !showProductImage && !showProductInfo;
  useMemo(function () {
    status === 'complete' && OOSProduct && errorLogger(new Error("[ERROR] " + clientId + " Quick Add Error message: Out of stock error"));
    status === 'error' && errorLogger(new Error("[ERROR] " + clientId + " Quick Add Error message: Error opening the component"));
  }, [status, data]); // This just addresses this requirement: https://gapinc.atlassian.net/browse/EVAL-2775

  var shouldShortenFrenchTexts = useMemo(function () {
    return data && status === 'complete' && locale === 'fr_CA';
  }, [data, status, locale]);
  var normalizedData = useMemo(function () {
    return shouldShortenFrenchTexts ? shortenFrenchLabels(data) : data;
  }, [data, shouldShortenFrenchTexts]);
  return jsx("div", {
    className: "quick-add " + className,
    css: getQuickAddContainerStyles(showProductImage, showProductInfo)
  }, jsx(ErrorBoundary, {
    componentName: "Quick Add",
    errorComponent: errorComponentJSX,
    errorLogger: errorLogger
  }, status === 'complete' && OOSProduct && OOSErrorComponentJSX, status === 'error' && errorComponentJSX, shouldDisplayProductInfoVersion && jsx(QuickAddContainerWithProductInfo, {
    addToBagUrls: addToBagUrls,
    brandName: brandName,
    clientId: clientId,
    data: normalizedData,
    enableLegacyAddToBag: enableLegacyAddToBag,
    errorLogger: errorLogger,
    locale: locale,
    onAddToBag: onAddToBag,
    pid: pid,
    powerReviewsConfig: powerReviewsConfig,
    reportQuickAddStart: reportQuickAddStart,
    reviews: reviews
  }), shouldDisplayProductImageVersion && jsx(QuickAddContainerWithImage, {
    addToBagUrls: addToBagUrls,
    clientId: clientId,
    data: normalizedData,
    enableLegacyAddToBag: enableLegacyAddToBag,
    errorLogger: errorLogger,
    onAddToBag: onAddToBag,
    pid: pid,
    reportQuickAddStart: reportQuickAddStart
  }), shouldDisplayDefaultVersion && jsx(QuickAddContainer, {
    addToBagUrls: addToBagUrls,
    clientId: clientId,
    data: normalizedData,
    enableLegacyAddToBag: enableLegacyAddToBag,
    errorLogger: errorLogger,
    onAddToBag: onAddToBag,
    pid: pid,
    reportQuickAddStart: reportQuickAddStart
  })));
}

var CLOSE_BUTTON_ARIA_LABEL = 'quickAdd.modal-close-button-aria-label';
var OPEN_BUTTON_ARIA_LABEL = 'quickAdd.toggle-open-button-aria-label';

var _templateObject$1, _templateObject2$1;

var Modal = function Modal(props) {
  var children = props.children,
      containerId = props.containerId,
      isOpen = props.isOpen,
      onClose = props.onClose,
      fullInfo = props.fullInfo;

  var _useLocalize = useLocalize(),
      localize = _useLocalize.localize;

  var modalWithImageStyles = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    padding: 0.5rem;\n    min-height: 597px;\n    min-width: 346px;\n    width: 346px;\n    position: relative;\n  "])));
  var modalWithoutImageStyles = css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    min-width: 43.313rem;\n    padding: 0.5rem;\n    position: relative;\n    width: fit-content;\n    @media (max-width: 693px) {\n      min-height: 35.875rem;\n      min-width: 21.625rem;\n    }\n  "])));
  var modalStyles = fullInfo ? modalWithImageStyles : modalWithoutImageStyles;
  return jsx$1(Modal$1, {
    autoFocus: true,
    closeButtonAriaLabel: localize(CLOSE_BUTTON_ARIA_LABEL),
    container: "#".concat(containerId),
    css: modalStyles,
    hasRoundedCorners: true,
    isOpen: isOpen,
    mobileFitSizeToContent: true,
    noHeader: true,
    onClose: onClose
  }, children);
};

var QuickAddIcon = function QuickAddIcon() {
  var iconBackgroundStyles = function iconBackgroundStyles() {
    return {
      filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.075))',
      overflow: 'visible'
    };
  };

  var fillStyles = function fillStyles(theme) {
    return {
      fill: theme.color.b1
    };
  };

  var strokeStyles = function strokeStyles(theme) {
    return {
      stroke: theme.color.b1
    };
  };

  return jsx$1("svg", {
    className: "cat_quick-add__icon",
    height: "36",
    viewBox: "0 0 36 36",
    width: "36",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx$1("g", {
    fill: "none"
  }, jsx$1("circle", {
    css: iconBackgroundStyles,
    cx: "18",
    cy: "18",
    fill: "#FFF",
    opacity: ".8",
    r: "17"
  }), jsx$1("path", {
    css: strokeStyles,
    d: "M16.253 6.826c-1.178 0-1.923.43-2.37 1.044-.626.858-.724 1.995-.716 2.681l6.165-.218c-.016-.713-.152-1.745-.754-2.523-.451-.583-1.186-.984-2.325-.984zM22.811 10.574H9.962v13.25a.934.934 0 0 0 .937.938h10.975a.934.934 0 0 0 .937-.937V10.574z"
  }), jsx$1("circle", {
    css: fillStyles,
    cx: "22.41",
    cy: "22.754",
    r: "6.692"
  }), ' ', jsx$1("circle", {
    cx: "22.41",
    cy: "22.754",
    r: "4.818"
  }), jsx$1("g", {
    stroke: "#FFF"
  }, jsx$1("path", {
    css: fillStyles,
    d: "M20.096 22.888h4.36M22.275 20.708v4.36"
  }))));
};

var buttonStyles = function buttonStyles(theme) {
  return {
    outline: 'none',
    border: 'none',
    position: 'absolute',
    padding: '0',
    height: '45px',
    width: '45px',
    bottom: '0.75rem',
    right: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    cursor: 'pointer',
    '&:hover,&:focus': {
      '& circle:first-of-type': {
        stroke: theme.color.b2,
        fill: '#F5F5F5',
        opacity: '1',
        strokeWidth: '1.5px'
      }
    }
  };
};

var ToggleButton = function ToggleButton(props) {
  var toggleOpen = props.toggleOpen,
      sendTealiumMetrics = props.sendTealiumMetrics;

  var _useLocalize = useLocalize(),
      localize = _useLocalize.localize;

  return jsx$1("button", {
    "aria-label": localize(OPEN_BUTTON_ARIA_LABEL),
    className: "cat_quick-add__toggle-button",
    css: buttonStyles,
    onClick: function onClick(e) {
      e.preventDefault();
      toggleOpen();
      sendTealiumMetrics();
    },
    type: "button"
  }, jsx$1(QuickAddIcon, null));
};

var ToggleManager = function ToggleManager(_ref) {
  var _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      children = _ref.children;

  var _useState = useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var toggleOpen = function toggleOpen() {
    return setOpen(function (prev) {
      return !prev;
    });
  };

  return children({
    open: open,
    toggleOpen: toggleOpen
  });
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getStyleId = function getStyleId(productId) {
  return productId.substring(0, 6);
};

var quickAddDataBuilder = function quickAddDataBuilder(datalayer) {
  return {
    onQuickAddStart: function onQuickAddStart(abbrNameForTealium, abbrBrand, categoryName, productName, productId) {
      datalayer.viewWith([{
        name: 'quickadd_start',
        data: {
          event_name: 'quickadd_start',
          page_name: "".concat(abbrNameForTealium, ":browse:QuickAddStart"),
          page_type: 'QuickAddStart',
          product_name: [productName],
          product_id: [getStyleId(productId)],
          product_brand: [abbrBrand.toUpperCase()],
          product_category: [categoryName]
        }
      }]);
    },
    onAddToBag: function onAddToBag(abbrNameForTealium, abbrBrand, categoryName, productId, reportingData) {
      datalayer.viewWith([{
        name: 'cart_add',
        data: _objectSpread(_objectSpread({}, reportingData), {}, {
          event_name: 'cart_add',
          page_name: "".concat(abbrNameForTealium, ":browse:QuickAdd"),
          page_type: 'QuickAdd',
          product_brand: [abbrBrand.toUpperCase()],
          product_category: [categoryName],
          product_id: [getStyleId(productId)]
        })
      }]);
    }
  };
};

var _templateObject, _templateObject2;
var QUICK_ADD_CLIENT_ID = 'PDPQuickAddCategory';
var index = (function (props) {
  var productId = props.productId,
      productName = props.productName,
      reviewCount = props.reviewCount,
      starRating = props.starRating; // @ts-ignore

  var _useContext = useContext(AppContext),
      breadcrumbs = _useContext.breadcrumbs,
      datalayer = _useContext.datalayer,
      enableLegacyAddToBag = _useContext.enableLegacyAddToBag,
      _useContext$isOverlay = _useContext.isOverlayViewForQuickAdd,
      isOverlayViewForQuickAdd = _useContext$isOverlay === void 0 ? false : _useContext$isOverlay,
      productStyleConfig = _useContext.productStyleConfig,
      _useContext$showProdu = _useContext.showProductImage,
      showProductImage = _useContext$showProdu === void 0 ? true : _useContext$showProdu,
      _useContext$showProdu2 = _useContext.showProductInfo,
      showProductInfo = _useContext$showProdu2 === void 0 ? true : _useContext$showProdu2;

  var _useContext2 = useContext(BreakpointContext),
      smallerThan = _useContext2.smallerThan;

  var _useContext3 = useContext(FeatureFlagsContext),
      enabledFeatures = _useContext3.enabledFeatures;

  var _useContext4 = useContext(BrandInfoContext),
      abbrNameForTealium = _useContext4.abbrNameForTealium,
      abbrBrand = _useContext4.abbrBrand; // TODO: merge and consume core ui changes to Breakpoint Provider


  var isMobile = isOverlayViewForQuickAdd || smallerThan(XLARGE);
  var finalEnableLegacyAddToBag = enableLegacyAddToBag === undefined ? Boolean(enabledFeatures['cat-legacy-add-to-bag']) : enableLegacyAddToBag; // These param numbers is derived from the height of the product-image,
  // with adjustments for the addToBag button, and container padding
  // future refactors should get these numbers more dynamically

  var quickAddContentHeight = function quickAddContentHeight(height, buttonHeight) {
    var adjustedHeight = height - buttonHeight;
    return "".concat(adjustedHeight, "px");
  };

  var responsiveMaxHeightForOverflow = isMobile ? '100%' : quickAddContentHeight(316, 34);
  var quickAddStyles = showProductImage ? css(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))) : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 100%;\n    padding-top: 0;\n    max-height: ", ";\n  "])), responsiveMaxHeightForOverflow);
  var toggleManagerContainerId = "cat-product-image-".concat(productId);

  var _quickAddDataBuilder = quickAddDataBuilder(datalayer),
      onAddToBag = _quickAddDataBuilder.onAddToBag,
      onQuickAddStart = _quickAddDataBuilder.onQuickAddStart;

  var onAddToBagHandler = function onAddToBagHandler(_ref, reportingData) {
    var status = _ref.status;

    if (status === 'SUCCESS') {
      var _breadcrumbs$category;

      onAddToBag(abbrNameForTealium, abbrBrand, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : (_breadcrumbs$category = breadcrumbs.category) === null || _breadcrumbs$category === void 0 ? void 0 : _breadcrumbs$category.name, productId, reportingData);
    }
  };

  var onQuickAddStartHandler = function onQuickAddStartHandler(isOpen) {
    return function () {
      if (!isOpen) {
        var _breadcrumbs$category2;

        onQuickAddStart(abbrNameForTealium, abbrBrand, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : (_breadcrumbs$category2 = breadcrumbs.category) === null || _breadcrumbs$category2 === void 0 ? void 0 : _breadcrumbs$category2.name, productName, productId);
      }
    };
  };

  var reviews = reviewCount && starRating ? {
    reviewCount: reviewCount,
    starRating: starRating
  } : null;
  return jsx$1("div", {
    className: "cat_quick-add",
    id: toggleManagerContainerId
  }, jsx$1(ToggleManager, null, function (_ref2) {
    var open = _ref2.open,
        toggleOpen = _ref2.toggleOpen;
    return jsx$1(React.Fragment, null, jsx$1(ToggleButton, {
      sendTealiumMetrics: onQuickAddStartHandler(open),
      toggleOpen: toggleOpen
    }), jsx$1(Modal, {
      containerId: toggleManagerContainerId,
      fullInfo: showProductImage && showProductInfo,
      isOpen: open,
      onClose: toggleOpen
    }, jsx$1(QuickAdd, {
      apiConfig: {
        pssApiKey: productStyleConfig === null || productStyleConfig === void 0 ? void 0 : productStyleConfig.apikey
      },
      clientId: QUICK_ADD_CLIENT_ID,
      css: quickAddStyles,
      enableLegacyAddToBag: finalEnableLegacyAddToBag,
      onAddToBag: onAddToBagHandler,
      pid: productId,
      reviews: reviews,
      showProductImage: showProductImage,
      showProductInfo: showProductInfo
    })));
  }));
});

export default index;
//# sourceMappingURL=quick-add.esm.js.map
